import { ExplanationJournal, U, linearInterpolationBySection1D, lPad, guessAdditionalPoints, linearInterpolationBySection3D, round10, UnitSystem, trunc10, trunc5, trunc3, trunc2, fromMetricAngle, fromMetricDistanceMilli, fromMetricTime, fromMetricTemperature, fromMetricPressureMega, fromMetricAreaMilli, fromMetricForce } from '@igus/kopla-domain';
import { produce } from 'immer';

const dryIgusMaterialNames = ['A160', 'A180', 'A181', 'A200', 'A230', 'A250', 'A350', 'A350-PF', 'A500', 'AB', 'ALW350', 'AX500', 'B', 'B180', 'C', 'C500', 'D', 'E', 'E7', 'ECO-A180', 'ECO-G', 'ECO-H', 'ECO-P', 'F', 'F2', 'F3', 'F300', 'FC-180', 'G', 'G1', 'GLW', 'GV0', 'H', 'H1', 'H2', 'H3', 'H370', 'H4', 'H5', 'HSD350', 'I10-PL', 'I150-PF', 'I151-PF', 'I180-BL-PF', 'I180-PF', 'I190-PL', 'I3-PL', 'I6-PL', 'I8-ESD', 'J', 'J-UV', 'J2', 'J200', 'J260', 'J260-PF', 'J3', 'J350', 'J3B', 'J4', 'JB', 'K', 'K230', 'L250', 'L350', 'L500', 'M210', 'M250', 'M260', 'N54', 'P', 'P-UV', 'P210', 'PA12-PL', 'PLW210', 'Q', 'Q2', 'Q290', 'Q3E', 'R', 'RN213', 'RN24', 'RN27', 'RN28', 'RN280', 'RN293', 'RN304', 'RN307', 'RN312', 'RN320', 'RN325', 'RN341', 'RN367', 'RN37', 'RN377', 'RN385', 'RN403', 'RN415', 'RN421', 'RN43', 'RN44', 'RN86', 'RN95', 'RW370', 'RW370-PF', 'S1-PL', 'T220', 'TX1', 'TX2', 'TX3', 'UW', 'UW160', 'UW500', 'V400', 'W300', 'W300E', 'W360', 'X', 'X6', 'Z', 'Z4'];

const dryOppositeMaterialIds = ['1', '15', '16', '17', '18', '2', '3', '4', '6', '8', '9'];

const dryOppositeMaterialNames = ['42CrMo4+QT', 'Aluminium h.c.', 'Automatenstahl', 'Cf53', 'Cf53 hartverchromt', 'St37', 'St37 gasnitriert', 'St37 nitrocarburiert', 'St37 verzinkt', 'V2A', 'X90'];

const material2PressureCof = [{
  igusMaterialName: 'A160',
  pressureCofList: [{
    pressure: 1,
    cof: 0.15
  }, {
    pressure: 5,
    cof: 0.12
  }, {
    pressure: 20,
    cof: 0.08
  }, {
    pressure: 45,
    cof: 0.07
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'A180',
  pressureCofList: [{
    pressure: 1,
    cof: 0.19
  }, {
    pressure: 5,
    cof: 0.13
  }, {
    pressure: 20,
    cof: 0.1
  }, {
    pressure: 45,
    cof: 0.09
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'A181',
  pressureCofList: [{
    pressure: 1,
    cof: 0.19
  }, {
    pressure: 5,
    cof: 0.15
  }, {
    pressure: 20,
    cof: 0.12
  }, {
    pressure: 45,
    cof: 0.1
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'A200',
  pressureCofList: [{
    pressure: 1,
    cof: 0.55
  }, {
    pressure: 5,
    cof: 0.32
  }, {
    pressure: 20,
    cof: 0.24
  }, {
    pressure: 45,
    cof: 0.18
  }, {
    pressure: 80,
    cof: 0.12
  }]
}, {
  igusMaterialName: 'A290',
  pressureCofList: [{
    pressure: 1,
    cof: 0.38
  }, {
    pressure: 5,
    cof: 0.31
  }, {
    pressure: 20,
    cof: 0.23
  }, {
    pressure: 45,
    cof: 0.13
  }, {
    pressure: 80,
    cof: 0.11
  }]
}, {
  igusMaterialName: 'A350',
  pressureCofList: [{
    pressure: 1,
    cof: 0.19
  }, {
    pressure: 5,
    cof: 0.13
  }, {
    pressure: 20,
    cof: 0.08
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'A500',
  pressureCofList: [{
    pressure: 1,
    cof: 0.48
  }, {
    pressure: 5,
    cof: 0.28
  }, {
    pressure: 20,
    cof: 0.18
  }, {
    pressure: 45,
    cof: 0.15
  }, {
    pressure: 80,
    cof: 0.12
  }]
}, {
  igusMaterialName: 'AB',
  pressureCofList: [{
    pressure: 1,
    cof: 0.22
  }, {
    pressure: 5,
    cof: 0.15
  }, {
    pressure: 20,
    cof: 0.09
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'B',
  pressureCofList: [{
    pressure: 1,
    cof: 0.29
  }, {
    pressure: 5,
    cof: 0.2
  }, {
    pressure: 20,
    cof: 0.12
  }, {
    pressure: 45,
    cof: 0.09
  }, {
    pressure: 80,
    cof: 0.05
  }]
}, {
  igusMaterialName: 'C',
  pressureCofList: [{
    pressure: 1,
    cof: 0.25
  }, {
    pressure: 5,
    cof: 0.19
  }, {
    pressure: 20,
    cof: 0.13
  }, {
    pressure: 45,
    cof: 0.12
  }, {
    pressure: 80,
    cof: 0.1
  }]
}, {
  igusMaterialName: 'C500',
  pressureCofList: [{
    pressure: 1,
    cof: 0.22
  }, {
    pressure: 5,
    cof: 0.16
  }, {
    pressure: 20,
    cof: 0.12
  }, {
    pressure: 45,
    cof: 0.09
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'D',
  pressureCofList: [{
    pressure: 1,
    cof: 0.31
  }, {
    pressure: 5,
    cof: 0.25
  }, {
    pressure: 20,
    cof: 0.18
  }, {
    pressure: 45,
    cof: 0.13
  }, {
    pressure: 80,
    cof: 0.09
  }]
}, {
  igusMaterialName: 'E',
  pressureCofList: [{
    pressure: 1,
    cof: 0.19
  }, {
    pressure: 5,
    cof: 0.13
  }, {
    pressure: 20,
    cof: 0.09
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'E7',
  pressureCofList: [{
    pressure: 1,
    cof: 0.25
  }, {
    pressure: 5,
    cof: 0.18
  }, {
    pressure: 20,
    cof: 0.11
  }, {
    pressure: 45,
    cof: 0.09
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'F',
  pressureCofList: [{
    pressure: 1,
    cof: 0.43
  }, {
    pressure: 5,
    cof: 0.26
  }, {
    pressure: 20,
    cof: 0.18
  }, {
    pressure: 45,
    cof: 0.12
  }, {
    pressure: 80,
    cof: 0.1
  }]
}, {
  igusMaterialName: 'F2',
  pressureCofList: [{
    pressure: 1,
    cof: 0.19
  }, {
    pressure: 5,
    cof: 0.15
  }, {
    pressure: 20,
    cof: 0.13
  }, {
    pressure: 45,
    cof: 0.11
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'G',
  pressureCofList: [{
    pressure: 1,
    cof: 0.3
  }, {
    pressure: 5,
    cof: 0.23
  }, {
    pressure: 20,
    cof: 0.18
  }, {
    pressure: 45,
    cof: 0.11
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'G1',
  pressureCofList: [{
    pressure: 1,
    cof: 0.22
  }, {
    pressure: 5,
    cof: 0.13
  }, {
    pressure: 20,
    cof: 0.11
  }, {
    pressure: 45,
    cof: 0.09
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'GV0',
  pressureCofList: [{
    pressure: 1,
    cof: 0.26
  }, {
    pressure: 5,
    cof: 0.18
  }, {
    pressure: 20,
    cof: 0.11
  }, {
    pressure: 45,
    cof: 0.09
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'GLW',
  pressureCofList: [{
    pressure: 1,
    cof: 0.29
  }, {
    pressure: 5,
    cof: 0.15
  }, {
    pressure: 20,
    cof: 0.12
  }, {
    pressure: 45,
    cof: 0.09
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'H',
  pressureCofList: [{
    pressure: 1,
    cof: 0.21
  }, {
    pressure: 5,
    cof: 0.11
  }, {
    pressure: 20,
    cof: 0.08
  }, {
    pressure: 45,
    cof: 0.07
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'HLW',
  pressureCofList: [{
    pressure: 1,
    cof: 0.22
  }, {
    pressure: 5,
    cof: 0.12
  }, {
    pressure: 20,
    cof: 0.1
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'H1',
  pressureCofList: [{
    pressure: 1,
    cof: 0.18
  }, {
    pressure: 5,
    cof: 0.11
  }, {
    pressure: 20,
    cof: 0.08
  }, {
    pressure: 45,
    cof: 0.06
  }, {
    pressure: 80,
    cof: 0.04
  }]
}, {
  igusMaterialName: 'H2',
  pressureCofList: [{
    pressure: 1,
    cof: 0.36
  }, {
    pressure: 5,
    cof: 0.18
  }, {
    pressure: 20,
    cof: 0.1
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'H370',
  pressureCofList: [{
    pressure: 1,
    cof: 0.22
  }, {
    pressure: 5,
    cof: 0.13
  }, {
    pressure: 20,
    cof: 0.09
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'H4',
  pressureCofList: [{
    pressure: 1,
    cof: 0.23
  }, {
    pressure: 5,
    cof: 0.15
  }, {
    pressure: 20,
    cof: 0.09
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'HSD350',
  pressureCofList: [{
    pressure: 1,
    cof: 0.19
  }, {
    pressure: 5,
    cof: 0.15
  }, {
    pressure: 20,
    cof: 0.09
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'J',
  pressureCofList: [{
    pressure: 1,
    cof: 0.19
  }, {
    pressure: 5,
    cof: 0.13
  }, {
    pressure: 20,
    cof: 0.09
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'JUV',
  pressureCofList: [{
    pressure: 1,
    cof: 0.19
  }, {
    pressure: 5,
    cof: 0.13
  }, {
    pressure: 20,
    cof: 0.08
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'J2',
  pressureCofList: [{
    pressure: 1,
    cof: 0.23
  }, {
    pressure: 5,
    cof: 0.13
  }, {
    pressure: 20,
    cof: 0.09
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'J200',
  pressureCofList: [{
    pressure: 1,
    cof: 0.17
  }, {
    pressure: 5,
    cof: 0.13
  }, {
    pressure: 20,
    cof: 0.1
  }, {
    pressure: 45,
    cof: 0.09
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'J260',
  pressureCofList: [{
    pressure: 1,
    cof: 0.19
  }, {
    pressure: 5,
    cof: 0.14
  }, {
    pressure: 20,
    cof: 0.09
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'J3',
  pressureCofList: [{
    pressure: 1,
    cof: 0.18
  }, {
    pressure: 5,
    cof: 0.13
  }, {
    pressure: 20,
    cof: 0.09
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'J3B',
  pressureCofList: [{
    pressure: 1,
    cof: 0.18
  }, {
    pressure: 5,
    cof: 0.13
  }, {
    pressure: 20,
    cof: 0.09
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'J350',
  pressureCofList: [{
    pressure: 1,
    cof: 0.19
  }, {
    pressure: 5,
    cof: 0.14
  }, {
    pressure: 20,
    cof: 0.09
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'J4',
  pressureCofList: [{
    pressure: 1,
    cof: 0.19
  }, {
    pressure: 5,
    cof: 0.13
  }, {
    pressure: 20,
    cof: 0.08
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'K',
  pressureCofList: [{
    pressure: 1,
    cof: 0.21
  }, {
    pressure: 5,
    cof: 0.15
  }, {
    pressure: 20,
    cof: 0.08
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'L250',
  pressureCofList: [{
    pressure: 1,
    cof: 0.2
  }, {
    pressure: 5,
    cof: 0.13
  }, {
    pressure: 20,
    cof: 0.09
  }, {
    pressure: 45,
    cof: 0.09
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'L350',
  pressureCofList: [{
    pressure: 1,
    cof: 0.17
  }, {
    pressure: 5,
    cof: 0.13
  }, {
    pressure: 20,
    cof: 0.08
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'L500',
  pressureCofList: [{
    pressure: 1,
    cof: 0.24
  }, {
    pressure: 5,
    cof: 0.18
  }, {
    pressure: 20,
    cof: 0.12
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'M250',
  pressureCofList: [{
    pressure: 1,
    cof: 0.55
  }, {
    pressure: 5,
    cof: 0.33
  }, {
    pressure: 20,
    cof: 0.25
  }, {
    pressure: 45,
    cof: 0.18
  }, {
    pressure: 80,
    cof: 0.12
  }]
}, {
  igusMaterialName: 'N54',
  pressureCofList: [{
    pressure: 1,
    cof: 0.17
  }, {
    pressure: 5,
    cof: 0.12
  }, {
    pressure: 20,
    cof: 0.09
  }, {
    pressure: 45,
    cof: 0.07
  }, {
    pressure: 80,
    cof: 0.05
  }]
}, {
  igusMaterialName: 'P',
  pressureCofList: [{
    pressure: 1,
    cof: 0.27
  }, {
    pressure: 5,
    cof: 0.17
  }, {
    pressure: 20,
    cof: 0.12
  }, {
    pressure: 45,
    cof: 0.1
  }, {
    pressure: 80,
    cof: 0.06
  }]
}, {
  igusMaterialName: 'P4',
  pressureCofList: [{
    pressure: 1,
    cof: 0.28
  }, {
    pressure: 5,
    cof: 0.18
  }, {
    pressure: 20,
    cof: 0.13
  }, {
    pressure: 45,
    cof: 0.11
  }, {
    pressure: 80,
    cof: 0.06
  }]
}, {
  igusMaterialName: 'P210',
  pressureCofList: [{
    pressure: 1,
    cof: 0.19
  }, {
    pressure: 5,
    cof: 0.14
  }, {
    pressure: 20,
    cof: 0.11
  }, {
    pressure: 45,
    cof: 0.09
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'Q',
  pressureCofList: [{
    pressure: 1,
    cof: 0.2
  }, {
    pressure: 5,
    cof: 0.11
  }, {
    pressure: 20,
    cof: 0.08
  }, {
    pressure: 45,
    cof: 0.07
  }, {
    pressure: 80,
    cof: 0.06
  }]
}, {
  igusMaterialName: 'Q2',
  pressureCofList: [{
    pressure: 1,
    cof: 0.3
  }, {
    pressure: 5,
    cof: 0.18
  }, {
    pressure: 20,
    cof: 0.14
  }, {
    pressure: 45,
    cof: 0.11
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'Q290',
  pressureCofList: [{
    pressure: 1,
    cof: 0.2
  }, {
    pressure: 5,
    cof: 0.18
  }, {
    pressure: 20,
    cof: 0.12
  }, {
    pressure: 45,
    cof: 0.09
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'R',
  pressureCofList: [{
    pressure: 1,
    cof: 0.22
  }, {
    pressure: 5,
    cof: 0.18
  }, {
    pressure: 20,
    cof: 0.12
  }, {
    pressure: 45,
    cof: 0.1
  }, {
    pressure: 80,
    cof: 0.09
  }]
}, {
  igusMaterialName: 'RW370',
  pressureCofList: [{
    pressure: 1,
    cof: 0.22
  }, {
    pressure: 5,
    cof: 0.16
  }, {
    pressure: 20,
    cof: 0.12
  }, {
    pressure: 45,
    cof: 0.09
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'TX1',
  pressureCofList: [{
    pressure: 1,
    cof: 0.38
  }, {
    pressure: 5,
    cof: 0.32
  }, {
    pressure: 20,
    cof: 0.25
  }, {
    pressure: 45,
    cof: 0.18
  }, {
    pressure: 80,
    cof: 0.16
  }]
}, {
  igusMaterialName: 'T220',
  pressureCofList: [{
    pressure: 1,
    cof: 0.52
  }, {
    pressure: 5,
    cof: 0.3
  }, {
    pressure: 20,
    cof: 0.25
  }, {
    pressure: 45,
    cof: 0.14
  }, {
    pressure: 80,
    cof: 0.11
  }]
}, {
  igusMaterialName: 'UW',
  pressureCofList: [{
    pressure: 1,
    cof: 0.33
  }, {
    pressure: 5,
    cof: 0.31
  }, {
    pressure: 20,
    cof: 0.23
  }, {
    pressure: 45,
    cof: 0.18
  }, {
    pressure: 80,
    cof: 0.12
  }]
}, {
  igusMaterialName: 'UW160',
  pressureCofList: [{
    pressure: 1,
    cof: 0.23
  }, {
    pressure: 5,
    cof: 0.17
  }, {
    pressure: 20,
    cof: 0.13
  }, {
    pressure: 45,
    cof: 0.1
  }, {
    pressure: 80,
    cof: 0.09
  }]
}, {
  igusMaterialName: 'UW500',
  pressureCofList: [{
    pressure: 1,
    cof: 0.36
  }, {
    pressure: 5,
    cof: 0.26
  }, {
    pressure: 20,
    cof: 0.15
  }, {
    pressure: 45,
    cof: 0.13
  }, {
    pressure: 80,
    cof: 0.11
  }]
}, {
  igusMaterialName: 'V400',
  pressureCofList: [{
    pressure: 1,
    cof: 0.2
  }, {
    pressure: 5,
    cof: 0.18
  }, {
    pressure: 20,
    cof: 0.14
  }, {
    pressure: 45,
    cof: 0.1
  }, {
    pressure: 80,
    cof: 0.07
  }]
}, {
  igusMaterialName: 'W300',
  pressureCofList: [{
    pressure: 1,
    cof: 0.23
  }, {
    pressure: 5,
    cof: 0.15
  }, {
    pressure: 20,
    cof: 0.09
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'W360',
  pressureCofList: [{
    pressure: 1,
    cof: 0.17
  }, {
    pressure: 5,
    cof: 0.12
  }, {
    pressure: 20,
    cof: 0.08
  }, {
    pressure: 45,
    cof: 0.07
  }, {
    pressure: 80,
    cof: 0.06
  }]
}, {
  igusMaterialName: 'X',
  pressureCofList: [{
    pressure: 1,
    cof: 0.33
  }, {
    pressure: 5,
    cof: 0.23
  }, {
    pressure: 20,
    cof: 0.18
  }, {
    pressure: 45,
    cof: 0.11
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'X6',
  pressureCofList: [{
    pressure: 1,
    cof: 0.23
  }, {
    pressure: 5,
    cof: 0.18
  }, {
    pressure: 20,
    cof: 0.08
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'Z',
  pressureCofList: [{
    pressure: 1,
    cof: 0.21
  }, {
    pressure: 5,
    cof: 0.13
  }, {
    pressure: 20,
    cof: 0.09
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.06
  }]
}, {
  igusMaterialName: 'I150-PF',
  pressureCofList: [{
    pressure: 1,
    cof: 0.28
  }, {
    pressure: 5,
    cof: 0.16
  }, {
    pressure: 20,
    cof: 0.1
  }, {
    pressure: 45,
    cof: 0.09
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'I180-PF',
  pressureCofList: [{
    pressure: 1,
    cof: 0.26
  }, {
    pressure: 5,
    cof: 0.15
  }, {
    pressure: 20,
    cof: 0.09
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'I3-PL',
  pressureCofList: [{
    pressure: 1,
    cof: 0.38
  }, {
    pressure: 5,
    cof: 0.18
  }, {
    pressure: 20,
    cof: 0.08
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'I6-PL',
  pressureCofList: [{
    pressure: 1,
    cof: 0.31
  }, {
    pressure: 5,
    cof: 0.2
  }, {
    pressure: 20,
    cof: 0.08
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'J260-PF',
  pressureCofList: [{
    pressure: 1,
    cof: 0.2
  }, {
    pressure: 5,
    cof: 0.14
  }, {
    pressure: 20,
    cof: 0.08
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.08
  }]
}, {
  igusMaterialName: 'I180-BL-PF',
  pressureCofList: [{
    pressure: 1,
    cof: 0.25
  }, {
    pressure: 5,
    cof: 0.15
  }, {
    pressure: 20,
    cof: 0.09
  }, {
    pressure: 45,
    cof: 0.08
  }, {
    pressure: 80,
    cof: 0.08
  }]
}];

var HousingMaterialIds;
(function (HousingMaterialIds) {
  HousingMaterialIds["steel"] = "1";
  HousingMaterialIds["aluminium"] = "2";
  HousingMaterialIds["greyCastIron"] = "3";
  HousingMaterialIds["stainlessSteel"] = "14";
  HousingMaterialIds["peHd"] = "4";
  HousingMaterialIds["polypropylene"] = "5";
  HousingMaterialIds["polyacetyl"] = "7";
  HousingMaterialIds["polyamide"] = "8";
  HousingMaterialIds["pc"] = "10";
  HousingMaterialIds["pbt"] = "11";
  HousingMaterialIds["ep"] = "13";
})(HousingMaterialIds || (HousingMaterialIds = {}));
var OppositeMaterialIds;
(function (OppositeMaterialIds) {
  OppositeMaterialIds["cf53"] = "1";
  OppositeMaterialIds["x105"] = "2";
  OppositeMaterialIds["v2a"] = "6";
  OppositeMaterialIds["aluHc"] = "8";
  OppositeMaterialIds["cf53Chromed"] = "9";
  OppositeMaterialIds["auto"] = "3";
  OppositeMaterialIds["st37"] = "4";
})(OppositeMaterialIds || (OppositeMaterialIds = {}));

const housingMaterials = [{
  housingMaterialId: HousingMaterialIds.steel,
  housingMaterialTranslationKey: 'STEEL',
  wtAdjustment: 0
}, {
  housingMaterialId: HousingMaterialIds.aluminium,
  housingMaterialTranslationKey: 'ALUMINUM',
  wtAdjustment: 0
}, {
  housingMaterialId: HousingMaterialIds.greyCastIron,
  housingMaterialTranslationKey: 'GREY_CAST_IRON',
  wtAdjustment: 0
}, {
  housingMaterialId: HousingMaterialIds.stainlessSteel,
  housingMaterialTranslationKey: 'STAINLESS_STEEL',
  wtAdjustment: 0
}, {
  housingMaterialId: HousingMaterialIds.peHd,
  housingMaterialTranslationKey: 'PE-HD',
  wtAdjustment: 10
}, {
  housingMaterialId: HousingMaterialIds.polypropylene,
  housingMaterialTranslationKey: 'POLYPROPYLENE',
  wtAdjustment: 10
}, {
  housingMaterialId: HousingMaterialIds.polyacetyl,
  housingMaterialTranslationKey: 'POLYACETYL',
  wtAdjustment: 10
}, {
  housingMaterialId: HousingMaterialIds.polyamide,
  housingMaterialTranslationKey: 'POLYAMIDE',
  wtAdjustment: 10
}, {
  housingMaterialId: HousingMaterialIds.pc,
  housingMaterialTranslationKey: 'PC',
  wtAdjustment: 10
}, {
  housingMaterialId: HousingMaterialIds.pbt,
  housingMaterialTranslationKey: 'PBT',
  wtAdjustment: 10
}, {
  housingMaterialId: HousingMaterialIds.ep,
  housingMaterialTranslationKey: 'EP',
  wtAdjustment: 10
}];

const oppositeMaterials = [{
  oppositeMaterialId: OppositeMaterialIds.cf53,
  oppositeMaterialTranslationKey: 'SWM',
  oppositeMaterialTrivialName: 'Cf53',
  oppositeMaterialDinName: '1.1213',
  thermalConductivity: 48
}, {
  oppositeMaterialId: OppositeMaterialIds.x105,
  oppositeMaterialTranslationKey: 'EWM',
  oppositeMaterialTrivialName: 'X105/X90',
  oppositeMaterialDinName: '1.4125/1.4112',
  thermalConductivity: 16
}, {
  oppositeMaterialId: OppositeMaterialIds.v2a,
  oppositeMaterialTranslationKey: 'EWMR',
  oppositeMaterialTrivialName: 'V2A',
  oppositeMaterialDinName: '1.4301',
  thermalConductivity: 16
}, {
  oppositeMaterialId: OppositeMaterialIds.aluHc,
  oppositeMaterialTranslationKey: 'AWMP',
  oppositeMaterialTrivialName: 'Alu hc',
  oppositeMaterialDinName: 'EN AW 6061/6060',
  thermalConductivity: 210
}, {
  oppositeMaterialId: OppositeMaterialIds.cf53Chromed,
  oppositeMaterialTranslationKey: 'SWMH',
  oppositeMaterialTrivialName: 'Cf53 chromed',
  oppositeMaterialDinName: '1.1213 HV',
  thermalConductivity: 48
}, {
  oppositeMaterialId: OppositeMaterialIds.auto,
  oppositeMaterialTranslationKey: 'DIN_1.0715',
  oppositeMaterialTrivialName: 'Automatenstahl',
  oppositeMaterialDinName: '1.0715',
  thermalConductivity: 48
}, {
  oppositeMaterialId: OppositeMaterialIds.st37,
  oppositeMaterialTranslationKey: 'DIN_1.0037',
  oppositeMaterialTrivialName: 'St37',
  oppositeMaterialDinName: '1.0037',
  thermalConductivity: 47
}];

/**
 * getPressureCofByMaterial returns pressure - coefficients of friction pairs for a given igus material
 *
 * If nothing is found an empty array is returned.
 */
const getPressureCofByIgusMaterialName = igusMaterialName => {
  const matchingMaterialData = material2PressureCof.filter(e => e.igusMaterialName === igusMaterialName);
  if (matchingMaterialData.length === 0) {
    return [];
  }
  if (matchingMaterialData.length === 1) {
    const pressureCofList = matchingMaterialData[0].pressureCofList;
    return pressureCofList.map(e => [e.pressure, e.cof]);
  }
  return [];
};
const calcCoefficientOfFriction = (igusMaterialName, surfacePressure) => {
  const Y = 1;
  const cofUnit = '';
  const journal = new ExplanationJournal();
  journal.addHeadline('coefficient of friction (µ):');
  journal.addText('  getPressureCofByIgusMaterialName()');
  const list = getPressureCofByIgusMaterialName(igusMaterialName);
  if (list.length === 0) {
    // FIXME: add option to return an error
    return {
      value: 0,
      unit: cofUnit,
      explanation: journal.getJournal()
    };
  }
  journal.addPoint1DList('cof list', list, 'MPa', cofUnit);
  const allU = list.map(e => e[U]);
  const uMin = Math.min(...allU);
  const uMax = Math.max(...allU);
  journal.addKeyValue('surfacePressure', surfacePressure, 'MPa');
  if (surfacePressure < uMin) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const yMin = list.find(e => e[U] === uMin)[Y];
    journal.addKeyValue('type of calculation', 'Explicatis shortcut for low values - see page 5/8 C. 1. Bulletpoint 4 ');
    journal.addKeyValue('possible improvement', 'add data-point [0, 0] and make linear interpolation');
    journal.addKeyValue('µ', yMin, cofUnit);
    return {
      value: yMin,
      unit: cofUnit,
      explanation: journal.getJournal()
    };
  }
  if (surfacePressure > uMax) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const yMax = list.find(e => e[U] === uMax)[Y];
    journal.addKeyValue('type of calculation', 'Explicatis shortcut for high values - see page 5/8 C. 1. Bulletpoint 4 ');
    journal.addKeyValue('µ', yMax, cofUnit);
    return {
      value: yMax,
      unit: cofUnit,
      explanation: journal.getJournal()
    };
  }
  const point = linearInterpolationBySection1D(list, surfacePressure);
  journal.addKeyValue('type of calculation', 'linear interpolation');
  journal.addKeyValue('µ', point[1], cofUnit);
  return {
    value: point[1],
    unit: cofUnit,
    explanation: journal.getJournal()
  };
};

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

const getIgusMaterialNames = () => {
  return dryIgusMaterialNames;
};
const getOppositeMaterialIds = () => {
  return dryOppositeMaterialIds;
};
const getOppositeMaterialNames = () => {
  return dryOppositeMaterialNames;
};
const getOppositeMaterials = () => {
  return oppositeMaterials;
};
const getHousingMaterials = () => {
  return housingMaterials;
};
const getOppositeMaterialById = oppositeMaterialId => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return oppositeMaterials.find(om => om.oppositeMaterialId === oppositeMaterialId);
};
const getHousingMaterialById = housingMaterialId => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return housingMaterials.find(hm => hm.housingMaterialId === housingMaterialId);
};
const getHousingMaterialEnumKey = housingMaterialId => Object.keys(HousingMaterialIds).find(k => HousingMaterialIds[k] === housingMaterialId);
const getOppositeMaterialEnumKey = oppositeMaterialId => Object.keys(OppositeMaterialIds).find(k => OppositeMaterialIds[k] === oppositeMaterialId);

class TrsExplanationJournal extends ExplanationJournal {
  constructor() {
    super(...arguments);
    this.addTrsLifetimeIntro = (title, body, isMultiple) => {
      var _body$pvCalculationPa;
      this.addTitle(title);
      if (isMultiple) {
        this.addText('>>> This calculation differs from the calculation in the iglidur Expert 3.0, <<<');
        this.addText('>>> because the TRS values reflect the real lifetime better. see IGL-983      <<<');
      }
      this.addHeadline('parameter:');
      if ('igusMaterialId' in body) {
        this.addKeyValue('igusMaterialId', body.igusMaterialId);
        this.addLinebreak();
      }
      if (body.oppositeMaterialId) {
        const oppositeMaterial = getOppositeMaterialById(body.oppositeMaterialId);
        this.addKeyValue('oppositeMaterialId', body.oppositeMaterialId);
        this.addKeyValue('oppositeMaterial', oppositeMaterial.oppositeMaterialTrivialName + ' (' + oppositeMaterial.oppositeMaterialTranslationKey + ')');
        this.addLinebreak();
      }
      if ((_body$pvCalculationPa = body.pvCalculationParams) != null && _body$pvCalculationPa.housingMaterialId) {
        const housingMaterial = getHousingMaterialById(body.pvCalculationParams.housingMaterialId);
        this.addKeyValue('housingMaterialId', body.pvCalculationParams.housingMaterialId);
        this.addKeyValue('housingMaterial', housingMaterial.housingMaterialTranslationKey);
        this.addLinebreak();
      }
      this.addKeyValue('environment', body.environment);
    };
    this.addTrsWearIntro = (title, body) => {
      this.addTitle(title);
      this.addHeadline('parameter:');
      if (body.igusMaterialId) {
        this.addKeyValue('igusMaterialId', body.igusMaterialId);
        this.addLinebreak();
      }
      if (body.oppositeMaterialId) {
        const oppositeMaterial = getOppositeMaterialById(body.oppositeMaterialId);
        this.addKeyValue('oppositeMaterialId', body.oppositeMaterialId);
        this.addKeyValue('oppositeMaterial', oppositeMaterial.oppositeMaterialTrivialName + ' (' + oppositeMaterial.oppositeMaterialTranslationKey + ')');
        this.addLinebreak();
      }
      this.addKeyValue('environment', body.environment);
    };
    this.addTrsResultKeyValue = (key, result) => {
      this.content += lPad(key, ' ', this.leftWidth) + ' = ' + (result.value || '') + (result.unit ? ' ' + result.unit : '') + '\n';
    };
  }
}

/* -----------------------------------------------
 * Mode of wear calculation
 * ----------------------------------------------- */
var ModeOfWearCalculation;
(function (ModeOfWearCalculation) {
  ModeOfWearCalculation["explicatis"] = "similar to explicatis";
  ModeOfWearCalculation["igels"] = "igels implementation";
  ModeOfWearCalculation["igelsAI"] = "igels ai implementation";
  //  explicatisOptimized = 'optimized explicatis approach',
  //  baseCurveDerived = 'base curve derived',
  //  neuronalNetworkPrediction = 'neuronalNetworkPrediction'
})(ModeOfWearCalculation || (ModeOfWearCalculation = {}));
var SpatialTypeOfMovementSingle;
(function (SpatialTypeOfMovementSingle) {
  SpatialTypeOfMovementSingle["rotation"] = "rotation";
  SpatialTypeOfMovementSingle["linear"] = "linear";
  SpatialTypeOfMovementSingle["pivoting"] = "pivoting";
})(SpatialTypeOfMovementSingle || (SpatialTypeOfMovementSingle = {}));
var SpatialTypeOfMovementDual;
(function (SpatialTypeOfMovementDual) {
  SpatialTypeOfMovementDual["linearAndRotation"] = "linear and rotation";
  SpatialTypeOfMovementDual["linearAndPivoting"] = "linear and pivoting";
})(SpatialTypeOfMovementDual || (SpatialTypeOfMovementDual = {}));
const spatialTypeOfMovements = _extends({}, SpatialTypeOfMovementSingle, SpatialTypeOfMovementDual);
const spatialTypeOfMovementsPerValues = Object.entries(spatialTypeOfMovements).reduce((acc, [key, value]) => _extends({}, acc, {
  [value]: key
}), {});
/* -----------------------------------------------
 * Temporal movement of the application
 * ----------------------------------------------- */
var TemporalTypeOfMovement;
(function (TemporalTypeOfMovement) {
  TemporalTypeOfMovement["simultaneous"] = "simultaneous";
  TemporalTypeOfMovement["sequential"] = "sequential";
})(TemporalTypeOfMovement || (TemporalTypeOfMovement = {}));
/* -----------------------------------------------
 * Environment of the application
 * ----------------------------------------------- */
var TechnicalEnvironment;
(function (TechnicalEnvironment) {
  TechnicalEnvironment["dry"] = "dry";
  TechnicalEnvironment["underWater"] = "underWater";
})(TechnicalEnvironment || (TechnicalEnvironment = {}));
/* -----------------------------------------------
 * Error messages
 * ----------------------------------------------- */
var WearError;
(function (WearError) {
  WearError["valid"] = "Valid";
  WearError["errorIgusMaterialNotSet"] = "Error: igus material not set";
  WearError["errorIgusMaterialNotFound"] = "Error: igus material not found";
  WearError["errorOppositeMaterialNotSet"] = "Error: opposite material not set";
  WearError["errorOppositeMaterialNotFound"] = "Error: opposite material not found";
  WearError["errorSpatialTypeOfMovementNotSet"] = "Error: spatial type of movement not set";
  WearError["errorSpatialTypeOfMovementNotYetSupported"] = "Error: spatial type of movement not yet supported";
  WearError["errorEnvironmentNotSet"] = "Error: environment not set";
  WearError["errorEnvironmentNotYetSupported"] = "Error: environment not yet supported";
  WearError["errorSurfacePressureNotSet"] = "Error: SurfacePressure not set";
  WearError["errorSurfacePressureOutOfRange"] = "Error: SurfacePressure out of range";
  WearError["errorTemperatureNotSet"] = "Error: Temperature not set";
  WearError["errorTemperatureOutOfRange"] = "Error: Temperature out of range";
  WearError["errorVelocityNotSet"] = "Error: Velocity not set";
  WearError["errorVelocityOutOfRange"] = "Error: Velocity out of range";
  WearError["errorNoData"] = "Error: No data for the given material combination and movement.";
  WearError["errorUndefinedWearCalculationMode"] = "Error: calculation mode is not defined.";
  WearError["errorUndefinedTypeOfMovement"] = "Error: type of movement not defined";
})(WearError || (WearError = {}));

/**
 * get the names of the spatialTypeOfMovementInExcel
 */
const getSpatialTypeOfMovementText = spatialTypeOfMovementInExcel => {
  switch (spatialTypeOfMovementInExcel) {
    case 1:
      return 'rotation';
    case 2:
      return 'linear';
    case 3:
      return 'pivoting';
  }
  return '';
};

const prepareWearResult = (wearResult, journal, wantExplanation) => {
  if (!wearResult) {
    return {
      error: WearError.errorNoData,
      explanation: journal.getJournal()
    };
  }
  journal.addKeyValue('=> wearValue', wearResult, 'nm/m');
  if (wantExplanation) {
    return {
      success: {
        value: wearResult,
        unit: 'nm/m',
        explanation: journal.getJournal()
      }
    };
  } else {
    return {
      success: {
        value: wearResult,
        unit: 'nm/m'
      }
    };
  }
};
const calculateWearExplicatis = (params, dryWearData) => {
  if (typeof params.wantExplanation === 'undefined') {
    params.wantExplanation = false;
  }
  const journal = new TrsExplanationJournal();
  journal.addTrsWearIntro('calculateWear( Explicatis )', params);
  journal.addHeadline('parameter validation:');
  journal.addKeyValue('spatialTypeOfMovementInExcel', params.spatialTypeOfMovementInExcel + ' (' + getSpatialTypeOfMovementText(params.spatialTypeOfMovementInExcel) + ')');
  journal.addKeyValue('surfacePressure', params.surfacePressure, 'MPa');
  journal.addKeyValue('temperature', params.temperature, '°C');
  journal.addKeyValue('velocity', params.velocity, 'm/s');
  // console.log('params', params);
  const reducedList = dryWearData.filter(e => e.igusMaterialName === params.igusMaterialId && e.oppositeMaterialId === params.oppositeMaterialId && e.typeOfMovement === params.spatialTypeOfMovementInExcel && e.wearValue < 9999);
  const points = reducedList.map(e => [e.pressure, e.velocity, e.temperature, e.wearValue]);
  journal.addLinebreak();
  journal.addPoint3DList('data', points);
  if (points.length === 0) {
    return {
      error: WearError.errorNoData,
      explanation: journal.getJournal()
    };
  }
  journal.addText('select temperature 23 °C');
  const selectedTemperature = 23;
  journal.addKeyValue('selectedTemperature', selectedTemperature, '°C');
  journal.addLinebreak();
  journal.addText('Assuming that without surfacePressure and velocity there is no actual wear of material, add starting point to ease interpolation for smaller values');
  points.unshift([0, 0, 23, 0]);
  journal.addLinebreak();
  // next lower pressure
  const nextLowerPressueValues = points.map(p => p[0]).filter(p => p <= params.surfacePressure).sort((a, b) => b - a);
  const nextLowerPressure = nextLowerPressueValues[0];
  // next bigger pressure
  const nextBiggerPressueValues = points.map(p => p[0]).filter(p => p >= params.surfacePressure).sort((a, b) => a - b);
  const nextBiggerPressure = nextBiggerPressueValues[0] || -1;
  journal.addKeyValue('nextLowerPressure : ', nextLowerPressure, 'MPa');
  journal.addKeyValue('nextBiggerPressure : ', nextBiggerPressure, 'MPa');
  journal.addLinebreak();
  let pointsD1 = [];
  if (nextLowerPressure >= 0 && nextBiggerPressure >= 0 && nextLowerPressure === nextBiggerPressure) {
    const results = points.find(p => p[0] === nextLowerPressure);
    return prepareWearResult(results == null ? void 0 : results[3], journal, params.wantExplanation);
  }
  if (nextBiggerPressure >= 0 && nextLowerPressure < nextBiggerPressure) {
    journal.addText('Approach: P first, filter min V');
    // list with possible lower p values sorted by v
    const pLPoints = points.filter(e => e[0] === nextLowerPressure).sort((a, b) => a[1] - b[1]).map(p => [p[0], p[3]]);
    // journal.addPoint1DList('lower data for interpolation', pLPoints, 'MPa', 'nm/m');
    // list with possible bigger p values sorted by v
    const pBPoints = points.filter(e => e[0] === nextBiggerPressure).sort((a, b) => a[1] - b[1]).map(p => [p[0], p[3]]);
    //journal.addPoint1DList('bigger data for interpolation', pBPoints, 'MPa', 'nm/m');
    pointsD1 = [pLPoints[0], pBPoints[0]];
  } else {
    journal.addText('Approach: V min first');
    journal.addText('filter minimal velocity from existing data (>= calculated velocity)');
    const givenVelocityArraySorted = points.map(p => p[1]).filter(v => v >= params.velocity).sort((a, b) => a - b);
    const selectedVelocity = givenVelocityArraySorted[0];
    journal.addKeyValue('selectedVelocity', selectedVelocity, 'm/s');
    journal.addLinebreak();
    pointsD1 = points.filter(p => p[1] === selectedVelocity && p[2] === selectedTemperature).map(p => [p[0], p[3]]);
    journal.addText('Add point 0,0 to fill the gap to the smaller values');
    pointsD1.unshift([0, 0]);
  }
  journal.addLinebreak();
  journal.addPoint1DList('data for interpolation', pointsD1, 'MPa', 'nm/m');
  let linearInterpolationResult;
  try {
    linearInterpolationResult = linearInterpolationBySection1D(pointsD1, params.surfacePressure);
  } catch (_unused) {
    return {
      error: WearError.errorNoData,
      explanation: journal.getJournal()
    };
  }
  journal.addHeadline('Linear interpolation result:');
  journal.addKeyValue('surefacePressure', params.surfacePressure, 'MPa');
  return prepareWearResult(linearInterpolationResult[1], journal, params.wantExplanation);
};

const calculateWearIgels = (params, dryWearData) => {
  if (typeof params.wantExplanation === 'undefined') {
    params.wantExplanation = false;
  }
  const journal = new TrsExplanationJournal();
  journal.addTrsWearIntro('calculateWear( Igels )', params);
  journal.addHeadline('parameter validation:');
  journal.addKeyValue('spatialTypeOfMovementInExcel', params.spatialTypeOfMovementInExcel + ' (' + getSpatialTypeOfMovementText(params.spatialTypeOfMovementInExcel) + ')');
  journal.addKeyValue('surfacePressure', params.surfacePressure, 'MPa');
  journal.addKeyValue('temperature', params.temperature, '°C');
  journal.addKeyValue('velocity', params.velocity, 'm/s');
  const reducedList = dryWearData.filter(e => e.igusMaterialName === params.igusMaterialId && e.oppositeMaterialId === params.oppositeMaterialId && e.typeOfMovement === params.spatialTypeOfMovementInExcel && e.wearValue < 9999);
  const pointsA = reducedList.map(e => [e.pressure, e.velocity, e.temperature, e.wearValue]);
  journal.addLinebreak();
  journal.addPoint3DList('data', pointsA);
  if (pointsA.length === 0) {
    return {
      error: WearError.errorNoData,
      explanation: 'bbbbb' + journal.getJournal()
    };
  }
  const pointsGuess = guessAdditionalPoints(pointsA);
  journal.addText('add some points by guessing');
  journal.addPoint3DList(' pointsGuess', pointsGuess);
  const points = pointsA.concat(pointsGuess);
  journal.addPoint3DList(' data', points);
  journal.addLinebreak();
  const wearValueResult = linearInterpolationBySection3D(points, params.surfacePressure, params.velocity, params.temperature);
  journal.addText(wearValueResult.explanation);
  journal.addPoint3D('resulting point', wearValueResult.point);
  const wearValue = wearValueResult.point[3];
  journal.addHeadline('result:');
  journal.addKeyValue('wearValue', wearValue, 'nm/m');
  if (params.wantExplanation) {
    return {
      success: {
        value: wearValue,
        unit: 'nm/m',
        explanation: journal.getJournal()
      }
    };
  } else {
    return {
      success: {
        value: wearValue,
        unit: 'nm/m'
      }
    };
  }
};

const calculateWearIgelsAI = params => {
  if (typeof params.wantExplanation === 'undefined') {
    params.wantExplanation = false;
  }
  const journal = new TrsExplanationJournal();
  journal.addTrsWearIntro('calculateWear( IgelsAI )', params);
  journal.addHeadline('parameter validation:');
  journal.addKeyValue('spatialTypeOfMovementInExcel', params.spatialTypeOfMovementInExcel + ' (' + getSpatialTypeOfMovementText(params.spatialTypeOfMovementInExcel) + ')');
  journal.addKeyValue('surfacePressure', params.surfacePressure, 'MPa');
  journal.addKeyValue('temperature', params.temperature, '°C');
  journal.addKeyValue('velocity', params.velocity, 'm/s');
  journal.addLinebreak();
  journal.addText('Not yet ready ...');
  if (params.wantExplanation) {
    return {
      success: {
        value: 0,
        unit: 'nm/m',
        explanation: journal.getJournal()
      }
    };
  } else {
    return {
      success: {
        value: 0,
        unit: 'nm/m'
      }
    };
  }
};

const getTypeOfMovementInExcel = spatialTypeOfMovementSingle => {
  if (spatialTypeOfMovementSingle === SpatialTypeOfMovementSingle.linear) {
    return 2; // linear
  } else if (spatialTypeOfMovementSingle === SpatialTypeOfMovementSingle.rotation) {
    return 1; // rotation
  } else if (spatialTypeOfMovementSingle === SpatialTypeOfMovementSingle.pivoting) {
    return 3; // pivoting
  }
  return undefined;
};
/**
 * calculateWearWithChecks calculates the wear for the given dimensions
 * The returned value is in µm/km that is equal to nm/m.
 */
const calculateWearWithChecks = (params, dryWearData) => {
  const journal = new TrsExplanationJournal();
  if (typeof params.modeOfWearCalculation === 'undefined') {
    params.modeOfWearCalculation = ModeOfWearCalculation.explicatis;
  }
  journal.addTitle('calculateWear( ' + params.modeOfWearCalculation + ' )');
  journal.addHeadline('parameter:');
  journal.addKeyValue('igusMaterialId', params.igusMaterialId);
  journal.addKeyValue('oppositeMaterialId', params.oppositeMaterialId);
  journal.addKeyValue('environment', params.environment);
  journal.addKeyValue('spatialTypeOfMovementSingle', params.spatialTypeOfMovementSingle);
  journal.addKeyValue('surfacePressure', params.surfacePressure, 'MPa');
  journal.addKeyValue('temperature', params.temperature, '°C');
  journal.addKeyValue('velocity', params.velocity, 'm/s');
  if (typeof params.surfacePressure === 'undefined') {
    return {
      error: WearError.errorSurfacePressureNotSet,
      explanation: journal.getJournal()
    };
  }
  if (typeof params.temperature === 'undefined') {
    return {
      error: WearError.errorTemperatureNotSet,
      explanation: journal.getJournal()
    };
  }
  if (typeof params.igusMaterialId === 'undefined') {
    return {
      error: WearError.errorIgusMaterialNotSet,
      explanation: journal.getJournal()
    };
  }
  if (typeof params.oppositeMaterialId === 'undefined') {
    return {
      error: WearError.errorOppositeMaterialNotSet,
      explanation: journal.getJournal()
    };
  }
  if (typeof params.spatialTypeOfMovementSingle === 'undefined') {
    return {
      error: WearError.errorSpatialTypeOfMovementNotSet,
      explanation: journal.getJournal()
    };
  }
  if (typeof params.environment === 'undefined') {
    return {
      error: WearError.errorEnvironmentNotSet,
      explanation: journal.getJournal()
    };
  }
  if (typeof params.velocity === 'undefined') {
    return {
      error: WearError.errorVelocityNotSet,
      explanation: journal.getJournal()
    };
  }
  const allIgusMaterials = getIgusMaterialNames();
  if (!allIgusMaterials.includes(params.igusMaterialId)) {
    return {
      error: WearError.errorIgusMaterialNotFound,
      explanation: journal.getJournal()
    };
  }
  const allOppositeMaterials = getOppositeMaterialIds();
  if (!allOppositeMaterials.includes(params.oppositeMaterialId)) {
    return {
      error: WearError.errorOppositeMaterialNotFound,
      explanation: journal.getJournal()
    };
  }
  if (params.spatialTypeOfMovementSingle !== SpatialTypeOfMovementSingle.linear && params.spatialTypeOfMovementSingle !== SpatialTypeOfMovementSingle.rotation && params.spatialTypeOfMovementSingle !== SpatialTypeOfMovementSingle.pivoting) {
    return {
      error: WearError.errorSpatialTypeOfMovementNotYetSupported,
      explanation: journal.getJournal()
    };
  }
  if (params.environment !== TechnicalEnvironment.dry) {
    return {
      error: WearError.errorEnvironmentNotYetSupported,
      explanation: journal.getJournal()
    };
  }
  if (params.surfacePressure <= 0 || params.surfacePressure > 100000) {
    return {
      error: WearError.errorSurfacePressureOutOfRange,
      explanation: journal.getJournal()
    };
  }
  if (params.temperature <= -254 || params.temperature > 1000) {
    return {
      error: WearError.errorTemperatureOutOfRange,
      explanation: journal.getJournal()
    };
  }
  if (params.velocity < 0 || params.velocity > 1000) {
    return {
      error: WearError.errorVelocityOutOfRange,
      explanation: journal.getJournal()
    };
  }
  const spatialTypeOfMovementInExcel = getTypeOfMovementInExcel(params.spatialTypeOfMovementSingle);
  if (!spatialTypeOfMovementInExcel) {
    return {
      error: WearError.errorUndefinedTypeOfMovement,
      explanation: journal.getJournal()
    };
  }
  if (params.modeOfWearCalculation === ModeOfWearCalculation.igels) {
    return calculateWearIgels(_extends({}, params, {
      spatialTypeOfMovementInExcel
    }), dryWearData);
  } else if (params.modeOfWearCalculation === ModeOfWearCalculation.igelsAI) {
    return calculateWearIgelsAI(_extends({}, params, {
      spatialTypeOfMovementInExcel
    }));
  } else if (params.modeOfWearCalculation === ModeOfWearCalculation.explicatis) {
    return calculateWearExplicatis(_extends({}, params, {
      spatialTypeOfMovementInExcel
    }), dryWearData);
  } else {
    return {
      error: WearError.errorUndefinedWearCalculationMode,
      explanation: journal.getJournal()
    };
  }
};
/**
 * Type-Guard to check if wearResult is a IWearSuccessResult
 */
const isWearSuccessResult = wearResult => {
  return wearResult.success !== undefined;
};
/**
 * Type-Guard to check if wearResult is a IWearErrorResult
 */
const isWearErrorResult = wearResult => {
  return wearResult.error !== undefined;
};

/**
 * Class to return Errors
 */
class LifetimeSingleResultError {
  constructor(error, igusMaterial, explanation, lifetimeParameters) {
    this.error = error;
    this.igusMaterial = igusMaterial;
    this.explanation = explanation;
    this.lifetimeParameters = lifetimeParameters;
  }
  isError() {
    return true;
  }
  isSuccess() {
    return false;
  }
  getError() {
    return this.error;
  }
  getExplanation() {
    return this.explanation || '';
  }
  getPlain(wantExplanation) {
    if (wantExplanation && this.explanation) {
      return {
        error: this.error,
        igusMaterial: this.igusMaterial,
        lifetimeParameters: this.lifetimeParameters,
        explanation: this.explanation
      };
    } else {
      return {
        error: this.error,
        igusMaterial: this.igusMaterial,
        lifetimeParameters: this.lifetimeParameters
      };
    }
  }
}
/**
 * Class to return Success
 */
class LifetimeSingleResultSuccess {
  constructor(igusMaterial, lifetime, velocity, wearPerHour, explanation, lifetimeParameters) {
    this.igusMaterial = igusMaterial;
    this.lifetime = lifetime;
    this.velocity = velocity;
    this.wearPerHour = wearPerHour;
    this.explanation = explanation;
    this.lifetimeParameters = lifetimeParameters;
  }
  isError() {
    return false;
  }
  isSuccess() {
    return true;
  }
  getIgusMaterial() {
    return this.igusMaterial;
  }
  getLifetime() {
    return this.lifetime;
  }
  getVelocity() {
    return this.velocity;
  }
  getWearPerHour() {
    return this.wearPerHour;
  }
  getExplanation() {
    return this.explanation || '';
  }
  getPlain(wantExplanation) {
    if (wantExplanation && this.explanation) {
      return {
        igusMaterial: this.igusMaterial,
        lifetime: this.lifetime,
        velocity: this.velocity,
        wearPerHour: this.wearPerHour,
        lifetimeParameters: this.lifetimeParameters,
        explanation: this.explanation
      };
    } else {
      return {
        igusMaterial: this.igusMaterial,
        lifetime: this.lifetime,
        velocity: this.velocity,
        wearPerHour: this.wearPerHour,
        lifetimeParameters: this.lifetimeParameters
      };
    }
  }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const toLifetimeSingleResult = body => {
  let result;
  if ('error' in body) {
    const b = body;
    result = new LifetimeSingleResultError(b.error, b.igusMaterial, b.explanation);
  } else {
    const b = body;
    result = new LifetimeSingleResultSuccess(b.igusMaterial, b.lifetime, b.velocity, b.wearPerHour, b.explanation);
  }
  return result;
};

const distanceFactor = 1 / 25.4; // 0,03937007874
/**
 * Convert imperial distance [in] to metric distance [mm]
 *
 * @param distanceImperial unit: [in]
 */
const distanceImperialToMetric = distanceImperial => {
  return round10(distanceImperial / distanceFactor);
};
/**
 * Convert metric distance [mm] to imperial distance [in]
 *
 * @param distanceMetric unit: [mm]
 */
const distanceMetricToImperial = distanceMetric => {
  return round10(distanceMetric * distanceFactor);
};

const areaFactor = distanceFactor * distanceFactor; // 0,0015500031
/**
 * Convert imperial area [in^2] to metric area [mm^2]
 *
 * @param areaImperial unit: [in^2]
 */
const areaImperialToMetric = areaImperial => {
  return round10(areaImperial / areaFactor);
};
/**
 * Convert metric area [mm^2] to imperial area [in^2]
 *
 * @param areaMetric unit: [mm^2]
 */
const areaMetricToImperial = areaMetric => {
  return round10(areaMetric * areaFactor);
};

const forceFactor = 0.2248089439;
/**
 * Convert imperial force [lbf] to metric force [N]
 *
 * @param forceImperial unit: [lbf]
 */
const forceImperialToMetric = forceImperial => {
  return round10(forceImperial / forceFactor);
};
/**
 * Convert metric force [N] to imperial force [lbf]
 *
 * @param forceMetric unit: [N]
 */
const forceMetricToImperial = forceMetric => {
  return round10(forceMetric * forceFactor);
};

const pressureFactor = forceFactor / areaFactor; //
/**
 * Convert imperial pressure [lbf/in^2] to metric pressure [MPa]
 *
 * @param pressureImperial unit: [lbf/in^2]
 */
const pressureImperialToMetric = pressureImperial => {
  return round10(pressureImperial / pressureFactor);
};
/**
 * Convert metric pressure [MPa] to imperial pressure [lbf/in^2]
 *
 * @param pressureMetric unit: [MPa]
 */
const pressureMetricToImperial = pressureMetric => {
  return round10(pressureMetric * pressureFactor);
};

/**
 * Convert imperial temperature [°F] to metric temperature [°C]
 *
 * @param temperatureImperial unit: [°F]
 */
const temperatureImperialToMetric = temperatureImperial => {
  return round10(5 / 9 * (temperatureImperial - 32));
};
/**
 * Convert metric temperature [°C] to imperial temperature [°F]
 *
 * @param temperatureMetric unit: [°C]
 */
const temperatureMetricToImperial = temperatureMetric => {
  return round10(temperatureMetric * 9 / 5 + 32);
};

const velocityFactor = distanceFactor * 1000;
/**
 * Convert imperial velocity [in/h] to metric velocity [m/h]
 *
 * @param velocityImperial unit: [in/h]
 */
const velocityImperialToMetric = velocityImperial => {
  return round10(velocityImperial / velocityFactor);
};
/**
 * Convert metric velocity [m/h] to imperial velocity [in/h]
 *
 * @param velocityMetric unit: [m/h]
 */
const velocityMetricToImperial = velocityMetric => {
  return round10(velocityMetric * velocityFactor);
};

const wearPerHourFactor = distanceFactor;
/**
 * Convert imperial wearPerHour [µin/h] to metric wearPerHour [nm/h]
 *
 * @param wearPerHourImperial unit: [µin/h]
 */
const wearPerHourImperialToMetric = wearPerHourImperial => {
  return round10(wearPerHourImperial / wearPerHourFactor);
};
/**
 * Convert metric wearPerHour [nm/h] to imperial wearPerHour [µin/h]
 *
 * @param wearPerHourMetric unit: [nm/h]
 */
const wearPerHourMetricToImperial = wearPerHourMetric => {
  return round10(wearPerHourMetric * wearPerHourFactor);
};

const adjustUnitSystemInRequestToMetric = params => {
  const journal = new ExplanationJournal();
  const result = produce(params, draft => {
    if (draft.unitSystem === UnitSystem.imperial) {
      var _draft$pvCalculationP;
      journal.addHeadline('input parameter conversion:');
      const impTemperature = draft.temperature;
      draft.temperature = temperatureImperialToMetric(draft.temperature);
      journal.addConversionKeyValue('temperature', impTemperature, '°F', draft.temperature, '°C');
      const impAcceptableWear = draft.acceptableWear;
      draft.acceptableWear = distanceImperialToMetric(draft.acceptableWear);
      journal.addConversionKeyValue('acceptableWear', impAcceptableWear, 'in', draft.acceptableWear, 'mm');
      // activityMinutesPerHour - no conversion required
      if ((_draft$pvCalculationP = draft.pvCalculationParams) != null && _draft$pvCalculationP.bearingLength) {
        const pvParams = draft.pvCalculationParams;
        const impBearingLength = pvParams.bearingLength;
        pvParams.bearingLength = distanceImperialToMetric(pvParams.bearingLength);
        journal.addConversionKeyValue('bearingLength', impBearingLength, 'in', pvParams.bearingLength, 'mm');
        if (pvParams.bearingWallThickness) {
          const wtParams = pvParams;
          const impBearingWallThickness = wtParams.bearingWallThickness;
          wtParams.bearingWallThickness = distanceImperialToMetric(wtParams.bearingWallThickness);
          journal.addConversionKeyValue('bearingWallThickness', impBearingWallThickness, 'in', wtParams.bearingWallThickness, 'mm');
        } else if (pvParams.bearingInnerDiameter) {
          const diameterParams = pvParams;
          const impBearingInnerDiameter = diameterParams.bearingInnerDiameter;
          diameterParams.bearingInnerDiameter = distanceImperialToMetric(diameterParams.bearingInnerDiameter);
          journal.addConversionKeyValue('bearingInnerDiameter', impBearingInnerDiameter, 'in', diameterParams.bearingInnerDiameter, 'mm');
          const impBearingOuterDiameter = diameterParams.bearingOuterDiameter;
          diameterParams.bearingOuterDiameter = distanceImperialToMetric(diameterParams.bearingOuterDiameter);
          journal.addConversionKeyValue('bearingOuterDiameter', impBearingOuterDiameter, 'in', diameterParams.bearingOuterDiameter, 'mm');
        }
      }
      // linear parameters
      if (draft.linearStrokeLength) {
        const p = draft;
        const impLinearStrokeLength = p.linearStrokeLength;
        p.linearStrokeLength = distanceImperialToMetric(p.linearStrokeLength);
        journal.addConversionKeyValue('linearStrokeLength', impLinearStrokeLength, 'in', p.linearStrokeLength, 'mm');
        // linearFrequency - no conversion required
      }
      if (draft.pivotingAngle) {
        // FIXME: this duplication can vanish when structure is flattened
        const p = draft;
        const impBearingInnerDiameter = p.bearingInnerDiameter;
        p.bearingInnerDiameter = distanceImperialToMetric(p.bearingInnerDiameter);
        journal.addConversionKeyValue('bearingInnerDiameter', impBearingInnerDiameter, 'in', p.bearingInnerDiameter, 'mm');
        // pivotingAngle - no conversion required
        // pivotingFrequency - no conversion required
      }
      // rotation parameters
      else if (draft.rotationRevolutions) {
        // FIXME: this duplication can vanish when structure is flattened
        const p = draft;
        const impBearingInnerDiameter = p.bearingInnerDiameter;
        p.bearingInnerDiameter = distanceImperialToMetric(p.bearingInnerDiameter);
        journal.addConversionKeyValue('bearingInnerDiameter', impBearingInnerDiameter, 'in', p.bearingInnerDiameter, 'mm');
        // rotationRevolutions - no conversion required
      }
      // load: LifetimeLoad
      if (draft.load.surfacePressure) {
        const load = draft.load;
        const impSurfacePressure = load.surfacePressure;
        load.surfacePressure = pressureImperialToMetric(load.surfacePressure);
        journal.addConversionKeyValue('surfacePressure', impSurfacePressure, 'lfb/in^2', load.surfacePressure, 'MPa');
      } else if (draft.load.force) {
        const load = draft.load;
        const impForce = load.force;
        load.force = forceImperialToMetric(load.force);
        journal.addConversionKeyValue('force', impForce, 'lfb', load.force, 'N');
        const impArea = load.area;
        load.area = areaImperialToMetric(load.area);
        journal.addConversionKeyValue('area', impArea, 'in^2', load.area, 'mm^2');
      }
      // onTime - no conversion required
      // offTime - no conversion required
      // temporalLinearPart - no conversion required
    }
  });
  return {
    value: result,
    explanation: journal.getJournal()
  };
};
/**
 *
 */
const adjustUnitSystemForResponseToImperial = (data, unitSystem) => {
  const logger = new TrsExplanationJournal();
  const result = produce(data, draft => {
    if (unitSystem === UnitSystem.metric) {
      logger.addHeadline('output parameter:');
      logger.addKeyValue('wearPerHour', draft.wearPerHour, 'nm/h');
    } else if (unitSystem === UnitSystem.imperial) {
      logger.addHeadline('output parameter conversion:');
      const impWearPerHour = wearPerHourMetricToImperial(draft.wearPerHour); //
      logger.addConversionKeyValue('wearPerHour', draft.wearPerHour, 'nm/h', impWearPerHour, 'µin/h');
      draft.wearPerHour = impWearPerHour;
      const impVelocity = velocityMetricToImperial(draft.velocity);
      logger.addConversionKeyValue('velocity', draft.velocity, 'm/s', impVelocity, 'ft/s');
      draft.velocity = impVelocity;
    }
    logger.addLinebreak();
    logger.addKeyValue('lifetime', draft.lifetime, 'h');
  });
  return {
    value: result,
    explanation: logger.getJournal()
  };
};

/**
 * Calculate the resulting PV (PV_tat) in Nm / s mm^2
 *
 * PV value is the sum of the surface pressure and the velocity and is a value that is proportional
 * to the heat in the part
 *
 * unit: N/mm^2 * m/s  <=> Nm / s mm^2
 *
 * @param surfacePressure  // unit: N/mm^2 (aka MPa)
 * @param velocity         // unit: m/h
 */
const calcResultingPV = (surfacePressure, velocity) => {
  const journal = new ExplanationJournal();
  journal.addHeadline('resulting PV:');
  const resultingPv = trunc5(surfacePressure * velocity / 3600);
  journal.addVisualProduct(['resultingPv', resultingPv, 'Nm / s mm^2', trunc5], [['surfacePressure', surfacePressure, 'N/mm^2'], ['velocity', velocity / 3600, 'm/s']]);
  return {
    value: resultingPv,
    unit: 'Nm / s mm^2',
    explanation: journal.getJournal()
  };
};
/**
 *
 * @param lambdaK heat conductivity of the bearing (igusMaterial) unit : W / m K
 * @param lambdaS heat conductivity of the rod (oppositeMaterial) unit : W / m K
 * @param mue coefficient of friction  (µ)  unit:
 * @param deltaTheta temperature difference unit: °K
 * @param wt wallthickness unit: mm
 * @param wtAdjustment wallthickness adjustment depending on the housing unit: mm
 * @param length  bearing length unit: mm
 */
const calcAllowedFormPV = (lambdaK, lambdaS, mue, deltaTheta, wt, wtAdjustment, length) => {
  const journal = new ExplanationJournal();
  journal.addHeadline('allowed form PV (Q):');
  journal.addText('The allowed PV value is the power that is created by friction every second.');
  journal.addText('PV = Qresult = Qbearing + Qrod');
  journal.addText('see book  >Konstruieren mit Kunststoff chapter 12.2< ');
  journal.addLinebreak();
  /**
   * constant for heat-transmission
   *
   * unit :
   */
  const k1 = 0.5;
  /**
   * constant for heat-transmission
   *
   * unit :
   */
  const k2 = 0.042;
  const partLeft = k1 * Math.PI * lambdaK * deltaTheta / (1000 * mue * (wt + wtAdjustment));
  journal.addVisualFraction(['Qbearing', partLeft, 'Nm / s mm^2', trunc10], [['k1', k1, ''], ['π', Math.PI, ''], ['λk', lambdaK, '(W / m K)'], ['Δϑ', deltaTheta, 'K']], [['1000', 1000, 'mm/m'], ['µ', mue, ''], ['(wt + wtA)', wt + wtAdjustment, 'mm']]);
  const partRight = k2 * Math.PI * lambdaS * deltaTheta / (1000 * mue * 2 * length);
  journal.addVisualFraction(['Qrod', partRight, 'Nm / s mm^2', trunc10], [['k2', k2, ''], ['π', Math.PI, ''], ['λs', lambdaS, '(W / m K)'], ['Δϑ', deltaTheta, 'K']], [['1000', 1000, 'mm/m'], ['µ', mue, ''], ['2', 2, ''], ['b1', length, 'mm']]);
  const resultingAllowedPv = partLeft + partRight;
  journal.addVisualSum(['PV_zul = Q', resultingAllowedPv, 'Nm / s mm^2', trunc5], [['Qbearing', trunc10(partLeft), 'Nm / s mm^2'], ['Qrod', trunc10(partRight), 'Nm / s mm^2']]);
  return {
    value: resultingAllowedPv,
    unit: 'Nm / s mm^2',
    explanation: journal.getJournal()
  };
};

/**
 * Type-Guard to check if pvCalc is a PvCalculationWtByWt
 */
const isPvCalculationParamsWtByWt = pvCalc => {
  return typeof pvCalc.bearingWallThickness !== 'undefined';
};
/**
 * Type-Guard to check if pvCalc is a PvCalculationWtByDiameters
 */
const isPvCalculationParamsWtByDiameters = pvCalc => {
  return typeof pvCalc.bearingInnerDiameter !== 'undefined';
};

const intermittentFactors = [{
  q: 4,
  tMax: 5,
  pvFactor: 8.0,
  vFactor: 4
}, {
  q: 4,
  tMax: 20,
  pvFactor: 5,
  vFactor: 2.5
}, {
  q: 4,
  tMax: 60,
  pvFactor: 3,
  vFactor: 1.5
}, {
  q: 4,
  tMax: 500,
  pvFactor: 1.8,
  vFactor: 1
}, {
  q: 3,
  tMax: 5,
  pvFactor: 6.0,
  vFactor: 3
}, {
  q: 3,
  tMax: 20,
  pvFactor: 4,
  vFactor: 2
}, {
  q: 3,
  tMax: 60,
  pvFactor: 2,
  vFactor: 1
}, {
  q: 3,
  tMax: 300,
  pvFactor: 1.6,
  vFactor: 1
}, {
  q: 2,
  tMax: 5,
  pvFactor: 4.0,
  vFactor: 2
}, {
  q: 2,
  tMax: 20,
  pvFactor: 2.4,
  vFactor: 1.2
}, {
  q: 2,
  tMax: 60,
  pvFactor: 1.8,
  vFactor: 1
}, {
  q: 2,
  tMax: 180,
  pvFactor: 1.2,
  vFactor: 1
}, {
  q: 1,
  tMax: 5,
  pvFactor: 2.3,
  vFactor: 1.15
}, {
  q: 1,
  tMax: 20,
  pvFactor: 1.85,
  vFactor: 1
}, {
  q: 1,
  tMax: 60,
  pvFactor: 1.25,
  vFactor: 1
}, {
  q: 1,
  tMax: 120,
  pvFactor: 1.1,
  vFactor: 1
}, {
  q: 0,
  tMax: 5,
  pvFactor: 1,
  vFactor: 1
}, {
  q: 0,
  tMax: 20,
  pvFactor: 1,
  vFactor: 1
}, {
  q: 0,
  tMax: 60,
  pvFactor: 1,
  vFactor: 1
}, {
  q: 0,
  tMax: 120,
  pvFactor: 1.1,
  vFactor: 1
}];

const calcIntermittentQuotient = intermittentParams => {
  let q = Math.trunc(intermittentParams.offTime / intermittentParams.onTime);
  if (q < 1) {
    q = 0;
  }
  if (q > 4) {
    q = 4;
  }
  return q;
};
const calcIntermittentTmax = intermittentParams => {
  const q = calcIntermittentQuotient(intermittentParams);
  const tMaxFind = intermittentFactors.filter(i => i.q === q).map(e => e.tMax).find(tMax => intermittentParams.onTime <= tMax);
  if (tMaxFind) {
    return tMaxFind;
  }
  return intermittentParams.onTime;
};
/**
 * calcIntermittentFactors returns the values for pvFactor and vFactor.
 *
 * If the given values do not lead into a usefull result both return values will be 1,
 * which means that the evaluation borders for PV value and V value are not changed.
 */
const calcIntermittentFactors = intermittentParams => {
  const q = calcIntermittentQuotient(intermittentParams);
  const tMax = calcIntermittentTmax(intermittentParams);
  if (!tMax) {
    return {
      pvFactor: 1,
      vFactor: 1,
      q,
      tMax: undefined
    };
  }
  const list = intermittentFactors.filter(if1 => if1.q === q).filter(if2 => if2.tMax === tMax);
  if (list.length !== 1) {
    return {
      pvFactor: 1,
      vFactor: 1,
      q,
      tMax
    };
  }
  return {
    pvFactor: list[0].pvFactor,
    vFactor: list[0].vFactor,
    q,
    tMax
  };
};

const parameterNames = ['temperature', 'acceptableWear', 'activityMinutesPerHour', 'bearingWallThickness', 'bearingInnerDiameter', 'bearingOuterDiameter', 'bearingLength', 'linearStrokeLength', 'linearFrequency', 'pivotingAngle', 'pivotingFrequency', 'rotationRevolutions', 'surfacePressure', 'force', 'area', 'onTime', 'offTime', 'temporalLinearPart'];
/**
 * return a list of all parameter limits
 *
 * The unit system here will not be used by the TRS-component because there thy need to be translated
 * properly into the different languages, but they are used in the explanations.
 *
 * @param unitSystem // default metric
 */
const getAllLifetimeInputParameterLimits = (unitSystem = UnitSystem.metric) => {
  const metricValues = {
    temperature: {
      unit: '°C',
      min: -273,
      max: 400,
      default: 23
    },
    acceptableWear: {
      unit: 'mm',
      min: 0.001,
      max: 2,
      default: 0.25
    },
    activityMinutesPerHour: {
      unit: 'min',
      min: 1,
      max: 60,
      default: 60
    },
    bearingInnerDiameter: {
      unit: 'mm',
      min: 1,
      max: 200,
      default: 10
    },
    bearingOuterDiameter: {
      unit: 'mm',
      min: 1,
      max: 200,
      default: 12
    },
    bearingWallThickness: {
      unit: 'mm',
      min: 0.5,
      max: 5,
      default: 1
    },
    bearingLength: {
      unit: 'mm',
      min: 1,
      max: 80,
      default: 15
    },
    // linear
    linearStrokeLength: {
      unit: 'mm',
      min: 1,
      max: 3000,
      default: 500
    },
    linearFrequency: {
      unit: '1/min',
      min: 1,
      max: 1000,
      default: 2
    },
    // pivoting
    pivotingAngle: {
      unit: '°',
      min: 0.1,
      max: 45,
      default: 10
    },
    pivotingFrequency: {
      unit: '1/min',
      min: 1,
      max: 1000,
      default: 2
    },
    // rotation
    rotationRevolutions: {
      unit: '1/min',
      min: 0.01,
      max: 1000,
      default: 2
    },
    surfacePressure: {
      unit: 'MPa',
      min: 0.00001,
      max: 100,
      default: 10
    },
    force: {
      unit: 'N',
      min: 0.00001,
      max: 100,
      default: 10
    },
    area: {
      unit: 'mm^2',
      min: 1,
      max: 1000,
      default: 100
    },
    // intermittent on- and offTime
    onTime: {
      unit: 's',
      min: 1,
      max: 600,
      default: 30
    },
    offTime: {
      unit: 's',
      min: 1,
      max: 600,
      default: 30
    },
    temporalLinearPart: {
      unit: '',
      min: 0,
      max: 1,
      default: 0.5
    }
  };
  const imperialValues = {
    temperature: {
      unit: '°F',
      min: temperatureMetricToImperial(metricValues.temperature.min),
      max: temperatureMetricToImperial(metricValues.temperature.max),
      default: temperatureMetricToImperial(metricValues.temperature.default)
    },
    acceptableWear: {
      unit: 'in',
      min: distanceMetricToImperial(metricValues.acceptableWear.min),
      max: distanceMetricToImperial(metricValues.acceptableWear.max),
      default: distanceMetricToImperial(metricValues.acceptableWear.default)
    },
    activityMinutesPerHour: metricValues.activityMinutesPerHour,
    bearingWallThickness: {
      unit: 'in',
      min: distanceMetricToImperial(metricValues.bearingWallThickness.min),
      max: distanceMetricToImperial(metricValues.bearingWallThickness.max),
      default: distanceMetricToImperial(metricValues.bearingWallThickness.default)
    },
    bearingInnerDiameter: {
      unit: 'in',
      min: distanceMetricToImperial(metricValues.bearingInnerDiameter.min),
      max: distanceMetricToImperial(metricValues.bearingInnerDiameter.max),
      default: distanceMetricToImperial(metricValues.bearingInnerDiameter.default)
    },
    bearingOuterDiameter: {
      unit: 'in',
      min: distanceMetricToImperial(metricValues.bearingOuterDiameter.min),
      max: distanceMetricToImperial(metricValues.bearingOuterDiameter.max),
      default: distanceMetricToImperial(metricValues.bearingOuterDiameter.default)
    },
    bearingLength: {
      unit: 'in',
      min: distanceMetricToImperial(metricValues.bearingLength.min),
      max: distanceMetricToImperial(metricValues.bearingLength.max),
      default: distanceMetricToImperial(metricValues.bearingLength.default)
    },
    // linear
    linearStrokeLength: {
      unit: 'in',
      min: distanceMetricToImperial(metricValues.linearStrokeLength.min),
      max: distanceMetricToImperial(metricValues.linearStrokeLength.max),
      default: distanceMetricToImperial(metricValues.linearStrokeLength.default)
    },
    linearFrequency: metricValues.linearFrequency,
    // pivoting
    pivotingAngle: metricValues.pivotingAngle,
    pivotingFrequency: metricValues.pivotingFrequency,
    // rotation
    rotationRevolutions: metricValues.rotationRevolutions,
    surfacePressure: {
      unit: 'lbf/in^2',
      min: pressureMetricToImperial(metricValues.surfacePressure.min),
      max: pressureMetricToImperial(metricValues.surfacePressure.max),
      default: pressureMetricToImperial(metricValues.surfacePressure.default)
    },
    force: {
      unit: 'lbf',
      min: forceMetricToImperial(metricValues.force.min),
      max: forceMetricToImperial(metricValues.force.max),
      default: forceMetricToImperial(metricValues.force.default)
    },
    area: {
      unit: 'in^2',
      min: areaMetricToImperial(metricValues.area.min),
      max: areaMetricToImperial(metricValues.area.max),
      default: areaMetricToImperial(metricValues.area.default)
    },
    // intermittent on- and offTime
    onTime: metricValues.onTime,
    offTime: metricValues.offTime,
    temporalLinearPart: metricValues.temporalLinearPart
  };
  if (unitSystem === UnitSystem.metric) {
    return metricValues;
  } else {
    return imperialValues;
  }
};
/**
 * return the limits for one key
 *
 * @param key // the key of the parameter
 * @param unitSystem // default : metric
 */
const getLifetimeInputParameterLimits = (key, unitSystem = UnitSystem.metric) => {
  return _extends({
    key
  }, getAllLifetimeInputParameterLimits(unitSystem)[key]);
};

/**
 * calcEffectiveVelocity
 *
 * value contains the effective velocity in m/s
 *
 * @param velocityMPS  unit : m/s
 * @param intermittentVFactor unit : 1
 */
const calcLogEffectiveIntermittentVelocity = (velocityMPS, intermittentVFactor) => {
  const journal = new ExplanationJournal();
  journal.addText('Take intermittent vFactor\ninto account for velocity:\n');
  const effectiveVelocityMPS = velocityMPS / intermittentVFactor;
  journal.addVisualFraction(['effectiveVelocity', trunc3(effectiveVelocityMPS), 'm/s'], [['velocity', trunc3(velocityMPS), 'm/s']], [['vFactor', trunc3(intermittentVFactor), '']]);
  return {
    value: effectiveVelocityMPS,
    unit: 'm/s',
    explanation: journal.getJournal()
  };
};
/**
 * get the effective surfacePressure from the LifetimeLoad object
 *
 * @param load LifetimeLoad object
 */
const getSurfacePressure = load => {
  let surfacePressure = 0;
  if (load.surfacePressure) {
    surfacePressure = load.surfacePressure;
  }
  if (load.force) {
    surfacePressure = load.force / load.area;
  }
  return surfacePressure;
};
/**
 * Calculate the temporal part of the pivoting movement.
 *
 * @param temporalLinearPart  // unit: 1
 */
const calcTemporalPivotingPart = temporalLinearPart => {
  const journal = new ExplanationJournal();
  const temporalPivotingPart = 1 - temporalLinearPart;
  journal.addKeyValue('temporalPivotingPart', '1 - temporalLinearPart');
  journal.addKeyValue('', 1 + ' - ' + temporalLinearPart);
  journal.addKeyValue('', temporalPivotingPart);
  journal.addLinebreak();
  return {
    value: temporalPivotingPart,
    unit: '',
    explanation: journal.getJournal()
  };
};
/**
 * Calculate the velocity of two sequential movements
 *
 * @param velocityA  // unit: m/h
 * @param velocityB  // unit: m/h
 */
const calcVelocitySequential = (velocityA, velocityB, typeA, typeB) => {
  const journal = new ExplanationJournal();
  const velocitySequential = Math.max(velocityA, velocityB);
  journal.addKeyValue('velocitySequential', 'MAX(' + typeA + '.velocity , ' + typeB + '.velocity)');
  journal.addKeyValue('', 'MAX(' + velocityA + ' m/h, ' + velocityB, ' m/h)');
  journal.addKeyValue('', velocitySequential, 'm/h');
  return {
    value: velocitySequential,
    unit: 'nm/h',
    explanation: journal.getJournal()
  };
};
/**
 * Calculate the velocity of two simultaneous movements
 *
 * @param velocityA  // unit: m/h
 * @param velocityB  // unit: m/h
 */
const calcVelocitySimultaneous = (velocityA, velocityB, typeA, typeB) => {
  const journal = new ExplanationJournal();
  const velocitySimultaneous = velocityA + velocityB;
  journal.addKeyValue('velocitySimultaneous', typeA + '.velocity + ' + typeB + '.velocity');
  journal.addKeyValue('', velocityA + ' m/h + ' + velocityB, ' m/h');
  journal.addKeyValue('', velocitySimultaneous, 'm/h');
  return {
    value: velocitySimultaneous,
    unit: 'nm/h',
    explanation: journal.getJournal()
  };
};
/**
 * Calculate the wear of two sequential movements
 *
 * @param wearPerHourA // unit: nm/h
 * @param wearPerHourB // unit: nm/h
 */
const calcWearPerHourSequential = (wearPerHourA,
// unit: nm/h
wearPerHourB,
// unit: nm/h
typeA, typeB, temporalPartA, temporalPartB, intermittentRatio) => {
  const journal = new ExplanationJournal();
  const wearPerHourSequential = (wearPerHourA * temporalPartA + wearPerHourB * temporalPartB) * intermittentRatio;
  journal.addKeyValue('wearPerHourSequential', '(' + typeA + '.wearPerHour * ' + typeA + '.temporalPart + ' + typeB + '.wearPerHour * ' + typeB + '.temporalPart ) * intermittentRatio ');
  journal.addKeyValue('', '(' + wearPerHourA + ' nm/h * ' + temporalPartA + ' + ' + wearPerHourB, ' nm/h * ' + temporalPartB + ') * ' + intermittentRatio);
  journal.addKeyValue('', wearPerHourSequential, 'nm/h');
  return {
    value: wearPerHourSequential,
    unit: 'nm/h',
    explanation: journal.getJournal()
  };
};
/**
 * Calculate the wear of two simultaneous movements
 *
 * @param wearPerHourA // unit: nm/h
 * @param wearPerHourB // unit: nm/h
 */
const calcWearPerHourSimultaneous = (wearPerHourA, wearPerHourB, typeA, typeB, intermittentRatio) => {
  const journal = new ExplanationJournal();
  // unit: nm/h
  const wearPerHourSimultaneous = (wearPerHourA + wearPerHourB) * intermittentRatio;
  journal.addKeyValue('wearPerHourSimultaneous', '(' + typeA + '.wearPerHour + ' + typeB + '.wearPerHour) * intermittentRatio');
  journal.addKeyValue('', '(' + wearPerHourA + ' nm/h + ' + wearPerHourB, ' nm/h ) * ' + intermittentRatio);
  journal.addKeyValue('', wearPerHourSimultaneous, 'nm/h');
  return {
    value: wearPerHourSimultaneous,
    unit: 'nm/h',
    explanation: journal.getJournal()
  };
};
/**
 * Calculate the time slice factor (DE: zeitlicher Bewegungsanteil)
 */
const calcTimeSliceFactor = activityMinutesPerHour => {
  const journal = new ExplanationJournal();
  const timeSliceFactor = activityMinutesPerHour / 60;
  journal.addVisualFraction(['timeSliceFactor', timeSliceFactor, ''], [['60', 60, 'min']], [['activityMinutesPerHour', activityMinutesPerHour, 'min']]);
  return {
    value: timeSliceFactor,
    unit: '',
    explanation: journal.getJournal()
  };
};
/**
 * Calculate the circumference (DE: Kreisumfang) in mm
 * of a given diameter.
 *
 * @param diameter // unit: mm
 */
const calcCircumference = diameter => {
  const journal = new ExplanationJournal();
  const circumference = diameter * Math.PI;
  journal.addVisualProduct(['circumference', circumference, 'mm'], [['diameter', diameter, 'mm'], ['π', Math.PI, '']]);
  return {
    value: circumference,
    unit: 'mm',
    explanation: journal.getJournal()
  };
};
/**
 * Calcualte the pivoting velocity (DE: Schwingungsgeschwindigkeit) in m/h
 *
 * @param timeSliceFactor                   // unit: 1
 * @param pivotingAngle                     // unit: °
 * @param circumference                     // unit: mm
 * @param pivotingFrequencyCountPerMinute   // unit: 1/min
 */
const calcPivotingVelocity = (timeSliceFactor, pivotingAngle, circumference, pivotingFrequencyCountPerMinute) => {
  const journal = new ExplanationJournal();
  const pivotingVelocity = trunc3(timeSliceFactor * pivotingAngle * circumference * 4 * pivotingFrequencyCountPerMinute * 60 / (360 * 1000));
  journal.addVisualFraction(['pivotingVelocity', pivotingVelocity, 'm/h', trunc3], [['timeSliceFactor', timeSliceFactor, ''], ['pivotingAngle', pivotingAngle, '°'], ['4', 4, ''], ['pivotingFrequencyCountPerMinute', pivotingFrequencyCountPerMinute, '1/min'], ['60', 60, 'min/h']], [['1000', 1000, 'mm/m'], ['360', 360, '°']]);
  return {
    value: pivotingVelocity,
    unit: 'm/h',
    explanation: journal.getJournal()
  };
};
/**
 * Calculate the rotation velocity (DE: Rotationsgeschwindigkeit) in m/h
 *
 * @param timeSliceFactor       // unit: 1
 * @param revolutionsPerMinute  // unit: 1/min
 * @param circumference         // unit: mm
 */
const calcRotationVelocity = (timeSliceFactor, revolutionsPerMinute, circumference) => {
  const journal = new ExplanationJournal();
  const rotationVelocity = trunc3(timeSliceFactor * (revolutionsPerMinute * circumference * 60 / 1000));
  journal.addVisualFraction(['rotationVelocity', rotationVelocity, 'm/h', trunc3], [['timeSliceFactor', timeSliceFactor, ''], ['revolutionsPerMinute', revolutionsPerMinute, '1/min'], ['circumference', circumference, 'mm'], ['60', 60, 'min/h']], [['1000', 1000, 'mm/m']]);
  return {
    value: rotationVelocity,
    unit: 'm/h',
    explanation: journal.getJournal()
  };
};
/**
 * Calculate linear velocity (DE: lineare Geschwindigkeit) in m/h
 *
 * @param timeSliceFactor                  // unit: 1
 * @param strokeLength                     // unit: mm
 * @param linearFrequencyCountPerMinute    // unit: 1/min
 */
const calcLinearVelocity = (timeSliceFactor, strokeLength, linearFrequencyCountPerMinute) => {
  const journal = new ExplanationJournal();
  const linearVelocity = trunc3(timeSliceFactor * strokeLength * 2 * linearFrequencyCountPerMinute * 60 / 1000);
  journal.addVisualFraction(['linearVelocity', linearVelocity, 'm/h', trunc3], [['timeSliceFactor', timeSliceFactor, ''], ['strokeLength', strokeLength, 'mm'], ['2', 2, ''], ['linearFrequencyCountPerMinute', linearFrequencyCountPerMinute, '1/min'], ['60', 60, 'min/h']], [['1000', 1000, 'mm/m']]);
  return {
    value: linearVelocity,
    unit: 'm/h',
    explanation: journal.getJournal()
  };
};
/**
 * Calculate the wearPerHour (DE: Verschleiß pro Stunde) in nm/h.
 *
 * @param velocity          // unit: m/h
 * @param intermittentRatio // unit: 1
 * @param wearValue         // unit: nm/m
 */
const calcWearPerHour = (velocity, intermittentRatio, wearValue) => {
  const journal = new ExplanationJournal();
  journal.addHeadline('Wear per hour:');
  const wearPerHour = velocity * intermittentRatio * wearValue;
  journal.addVisualFraction(['wearPerHour', wearPerHour, 'nm/h'], [['velocity', velocity, 'm/h'], ['intermittentRatio', intermittentRatio, ''], ['wearValue', wearValue, 'nm/m']], []);
  return {
    value: wearPerHour,
    unit: 'nm/h',
    explanation: journal.getJournal()
  };
};
/**
 * Calculate the liftime (DE: Lebensdauer) in h.
 *
 * @param acceptableWear // unit: mm
 * @param wearPerHour    // unit: nm/h
 */
const calcLifetime = (acceptableWear, wearPerHour) => {
  const journal = new ExplanationJournal();
  const lifetime = trunc2(acceptableWear * 1000000 / wearPerHour);
  journal.addVisualFraction(['lifetime', lifetime, 'h', trunc2], [['acceptableWear', acceptableWear, 'mm'], ['1000000', 1000000, 'nm/mm']], [['wearPerHour', wearPerHour, 'nm/h']]);
  return {
    value: lifetime,
    unit: 'h',
    explanation: journal.getJournal()
  };
};
/**
 * Calculate the service life (DE : Laufleistung) in km
 * This will only be used for single movements, because it does
 * not make sense to add service life in different directions.
 *
 * @param acceptableWear  // unit: mm
 * @param wearValue       // unit: µm/km  ( <=> nm/m )
 */
const calcServiceLife = (acceptableWear, wearValue) => {
  const journal = new ExplanationJournal();
  const serviceLife = trunc2(acceptableWear * 1000 / wearValue);
  journal.addVisualFraction(['serivceLife', serviceLife, 'km', trunc2], [['acceptableWear', acceptableWear, 'mm'], ['1000', 1000, 'µm/mm']], [['wearValue', wearValue, 'µm/km']]);
  return {
    value: serviceLife,
    unit: 'km',
    explanation: journal.getJournal()
  };
};
/**
 * Check existence and min and max values (when given) for the given rows.
 * Each row is logged to the Logger and the result is the number of checks that failed.
 */
const checkValues = rows => {
  const journal = new ExplanationJournal();
  let errorCount = 0;
  for (const r of rows) {
    let valueOk = true;
    let minOk = true;
    let maxOk = true;
    let reason = '';
    if (typeof r.value === 'undefined') {
      valueOk = false;
      reason += ' value not defined ';
    } else {
      if (typeof r.min !== 'undefined' && r.value < r.min) {
        minOk = false;
        reason += ' value lower than min ' + r.min + ' ' + (r.unit || '') + ' ';
      }
      if (typeof r.max !== 'undefined' && r.value > r.max) {
        maxOk = false;
        reason += ' value bigger than max ' + r.max + ' ' + (r.unit || '') + ' ';
      }
    }
    const isValid = valueOk && minOk && maxOk;
    journal.addCheckValue(r.key, r.value, r.unit, isValid, reason);
    if (!isValid) {
      errorCount++;
    }
  }
  journal.addLinebreak();
  return {
    value: errorCount,
    unit: '',
    explanation: journal.getJournal()
  };
};
/**
 * calculates the resultingPV and the allowedPV if all parameters are available
 *
 * missing parameters are not causing an error so the calculation is not stopped in this case
 * value is 1 in this case (WARNING)
 *
 * if all parameters are available the calculations are done
 * if resultingPV < allowedPV the return value is 0  (OK)
 * otherwise it is 2 (ERROR)
 *
 */
const calcLogPvValues = (mue, temperature, surfacePressure, velocity, igusMaterialDetails, oppositeMaterialId, pvCalculationParams, intermittentPvFactor) => {
  var _housingMaterial3;
  const journal = new ExplanationJournal();
  const OK = 0;
  const WARNING = 1;
  const ERROR = 2;
  let wt;
  const checkPvValueRows = [];
  if (isPvCalculationParamsWtByWt(pvCalculationParams)) {
    wt = pvCalculationParams.bearingWallThickness;
    checkPvValueRows.push({
      key: 'wallthickness',
      value: pvCalculationParams.bearingWallThickness,
      unit: 'mm',
      min: 1,
      max: 100
    });
  } else {
    wt = (pvCalculationParams.bearingOuterDiameter - pvCalculationParams.bearingInnerDiameter) / 2;
    checkPvValueRows.push({
      key: 'innerDiameter',
      value: pvCalculationParams.bearingInnerDiameter,
      unit: 'mm',
      min: 1,
      max: 100
    }, {
      key: 'outerDiameter',
      value: pvCalculationParams.bearingOuterDiameter,
      unit: 'mm',
      min: 1,
      max: 100
    });
  }
  let oppositeMaterial;
  let housingMaterial;
  if (igusMaterialDetails) {
    if (igusMaterialDetails != null && igusMaterialDetails.thermalConductivity) {
      checkPvValueRows.push({
        key: 'length',
        value: pvCalculationParams.bearingLength,
        unit: 'mm',
        min: 1,
        max: 1000
      }, {
        key: 'im.thermalConductivity',
        value: igusMaterialDetails == null ? void 0 : igusMaterialDetails.thermalConductivity,
        unit: ''
      });
    } else {
      journal.addText('thermalConductivity is not set in igusMaterialDetails');
      return {
        value: WARNING,
        unit: '',
        explanation: journal.getJournal()
      };
    }
    if (igusMaterialDetails != null && igusMaterialDetails.maxTemperature) {
      checkPvValueRows.push({
        key: 'im.maxTemperature',
        value: igusMaterialDetails == null ? void 0 : igusMaterialDetails.maxTemperature,
        unit: '°C'
      });
    } else {
      journal.addText('maxTemperature is not set in igusMaterialDetails');
      return {
        value: WARNING,
        unit: '',
        explanation: journal.getJournal()
      };
    }
  } else {
    journal.addText('igusMaterialDetails not defined');
    return {
      value: WARNING,
      unit: '',
      explanation: journal.getJournal()
    };
  }
  if (oppositeMaterialId) {
    oppositeMaterial = getOppositeMaterialById(oppositeMaterialId);
    if (oppositeMaterial) {
      var _oppositeMaterial;
      if ((_oppositeMaterial = oppositeMaterial) != null && _oppositeMaterial.thermalConductivity) {
        var _oppositeMaterial2;
        checkPvValueRows.push({
          key: 'om.thermalConductivity',
          value: (_oppositeMaterial2 = oppositeMaterial) == null ? void 0 : _oppositeMaterial2.thermalConductivity,
          unit: ''
        });
      } else {
        journal.addText('thermalConductivity is not set in oppositeMaterial');
        return {
          value: WARNING,
          unit: '',
          explanation: journal.getJournal()
        };
      }
    } else {
      journal.addText('oppositeMaterial not defined');
      return {
        value: WARNING,
        unit: '',
        explanation: journal.getJournal()
      };
    }
  } else {
    journal.addText('oppositeMaterialId not defined');
    return {
      value: WARNING,
      unit: '',
      explanation: journal.getJournal()
    };
  }
  if (pvCalculationParams.housingMaterialId) {
    housingMaterial = getHousingMaterialById(pvCalculationParams.housingMaterialId);
    if (housingMaterial) {
      var _housingMaterial;
      if (typeof ((_housingMaterial = housingMaterial) == null ? void 0 : _housingMaterial.wtAdjustment) !== 'undefined') {
        var _housingMaterial2;
        checkPvValueRows.push({
          key: 'hm.wtAdjustement',
          value: (_housingMaterial2 = housingMaterial) == null ? void 0 : _housingMaterial2.wtAdjustment,
          unit: ''
        });
      } else {
        journal.addText('wtAdjustment is not defined in housingMaterial');
        return {
          value: WARNING,
          unit: '',
          explanation: journal.getJournal()
        };
      }
    } else {
      journal.addText('housingMaterial not defined');
      return {
        value: WARNING,
        unit: '',
        explanation: journal.getJournal()
      };
    }
  } else {
    journal.addText('housingMaterialId not defined');
    return {
      value: WARNING,
      unit: '',
      explanation: journal.getJournal()
    };
  }
  const checkPvResult = checkValues(checkPvValueRows);
  journal.addText(checkPvResult.explanation);
  if (checkPvResult.value > 0) {
    journal.addText('PV values not valid or not complete');
    return {
      value: WARNING,
      unit: '',
      explanation: journal.getJournal()
    };
  }
  const lambdaK = igusMaterialDetails.thermalConductivity || 1;
  const lambdaS = oppositeMaterial.thermalConductivity;
  const deltaTheta = igusMaterialDetails.maxTemperature - temperature + 0.1;
  const wtAdjustment = ((_housingMaterial3 = housingMaterial) == null ? void 0 : _housingMaterial3.wtAdjustment) || 0;
  const allowedFormPV = calcAllowedFormPV(lambdaK, lambdaS, mue.value, deltaTheta, wt, wtAdjustment, pvCalculationParams.bearingLength);
  journal.addSubText(allowedFormPV.explanation);
  const resultingPvResult = calcResultingPV(surfacePressure, velocity);
  journal.addSubText(resultingPvResult.explanation);
  const effectivePvValue = resultingPvResult.value / intermittentPvFactor;
  journal.addVisualFraction(['effectivePvValue', trunc3(effectivePvValue), 'Nm / s mm^2'], [['resultingPv', trunc3(resultingPvResult.value), 'Nm / s mm^2']], [['PvFactor', trunc3(intermittentPvFactor), '']]);
  const maxAllowedPressureVelocity = (igusMaterialDetails == null ? void 0 : igusMaterialDetails.maxAllowedPressureVelocity) || 0;
  if (effectivePvValue > maxAllowedPressureVelocity) {
    journal.addText('Effective PV (' + effectivePvValue + ' Nm / s mm^2 ) is bigger than the allowed materialPV  (' + maxAllowedPressureVelocity + ' Nm / s mm^2 ) Application will not work!  ❌');
    return {
      value: WARNING,
      unit: '',
      explanation: journal.getJournal()
    };
  } else {
    journal.addText('Effective PV (' + effectivePvValue + ' Nm / s mm^2 ) is lower than the allowed materialPV (' + maxAllowedPressureVelocity + ' Nm / s mm^2 ) ✅');
    journal.addLinebreak();
  }
  const pvDiff = allowedFormPV.value - effectivePvValue;
  journal.addHeadline('PV validation:');
  if (pvDiff < 0) {
    journal.addText('Effective PV (' + effectivePvValue + ' Nm / s mm^2 ) is bigger than the allowed formPV (' + allowedFormPV.value + ' Nm / s mm^2 ) => Application will not work! ❌');
    return {
      value: ERROR,
      unit: '',
      explanation: journal.getJournal()
    };
  } else {
    journal.addText('Effective PV (' + effectivePvValue + ' Nm / s mm^2 ) is lower than the allowed formPV (' + allowedFormPV.value + ' Nm / s mm^2 ) ✅');
    journal.addLinebreak();
  }
  journal.addLinebreak();
  return {
    value: OK,
    unit: '',
    parameters: {
      effectivePvValue,
      maxAllowedPressureVelocity,
      maxPermissiblePressureValue: allowedFormPV.value,
      intermittentPvFactor
    },
    explanation: journal.getJournal()
  };
};
const getCommonCheckRows = (surfacePressure, body) => {
  return [_extends({
    value: surfacePressure
  }, getLifetimeInputParameterLimits('surfacePressure', body.unitSystem)), _extends({
    value: body.temperature
  }, getLifetimeInputParameterLimits('temperature', body.unitSystem)), _extends({
    value: body.acceptableWear
  }, getLifetimeInputParameterLimits('acceptableWear', body.unitSystem)), _extends({
    value: body.activityMinutesPerHour
  }, getLifetimeInputParameterLimits('activityMinutesPerHour', body.unitSystem))];
};
const getLinParameterCheckRows = (strokeLength, linearFrequencyCountPerMinute, maxLinVelocity) => {
  return [_extends({
    value: strokeLength
  }, getLifetimeInputParameterLimits('linearStrokeLength')), _extends({
    value: linearFrequencyCountPerMinute
  }, getLifetimeInputParameterLimits('linearFrequency')), {
    key: 'maxLinVelocity',
    value: maxLinVelocity || 0,
    unit: 'm/s'
  }];
};
const getPivCheckRows = (diameter, pivotingAngle, pivotingFrequencyCountPerMinute, maxPivVelocity) => {
  return [_extends({
    value: diameter
  }, getLifetimeInputParameterLimits('bearingInnerDiameter')), _extends({
    value: pivotingAngle
  }, getLifetimeInputParameterLimits('pivotingAngle')), _extends({
    value: pivotingFrequencyCountPerMinute
  }, getLifetimeInputParameterLimits('pivotingFrequency')), {
    key: 'maxPivVelocity',
    value: maxPivVelocity || 0,
    unit: 'm/s'
  }];
};
const getRotParameterCheckRows = (diameter, revolutionsPerMinute, maxRotVelocity) => {
  return [_extends({
    value: diameter
  }, getLifetimeInputParameterLimits('bearingInnerDiameter')), _extends({
    value: revolutionsPerMinute
  }, getLifetimeInputParameterLimits('rotationRevolutions')), {
    key: 'maxRotVelocity',
    value: maxRotVelocity || 0,
    unit: 'm/s'
  }];
};
/**
 * calculate and log the factors for intermittent operation
 */
const calcLogIntermittentFactors = body => {
  const journal = new ExplanationJournal();
  journal.addTitle('calcLogIntermittentFactors() ');
  if (body.intermittentParams) {
    var _body$intermittentPar, _body$intermittentPar2, _body$intermittentPar3, _body$intermittentPar4;
    const checkIntermittentFactors = [_extends({
      value: (_body$intermittentPar = body.intermittentParams) == null ? void 0 : _body$intermittentPar.onTime
    }, getLifetimeInputParameterLimits('onTime')), _extends({
      value: (_body$intermittentPar2 = body.intermittentParams) == null ? void 0 : _body$intermittentPar2.offTime
    }, getLifetimeInputParameterLimits('offTime'))];
    const checkIntermittentFactorsResult = checkValues(checkIntermittentFactors);
    journal.addText(checkIntermittentFactorsResult.explanation);
    if (checkIntermittentFactorsResult.value > 0) {
      const errorText = checkIntermittentFactorsResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
      return new LifetimeSingleResultError(errorText, journal.getJournal());
    }
    journal.addKeyValue('onTime ', (_body$intermittentPar3 = body.intermittentParams) == null ? void 0 : _body$intermittentPar3.onTime, 's');
    journal.addKeyValue('offTime ', (_body$intermittentPar4 = body.intermittentParams) == null ? void 0 : _body$intermittentPar4.offTime, 's');
    journal.addLinebreak();
    const r = calcIntermittentFactors(body.intermittentParams);
    journal.addKeyValue('Result q ', r == null ? void 0 : r.q, '');
    journal.addKeyValue('Result tmax ', r == null ? void 0 : r.tMax, 's');
    journal.addLinebreak();
    journal.addKeyValue('Result pvFactor ', r.pvFactor, '');
    journal.addKeyValue('Result vFactor ', r.vFactor, '');
    r.explanation = journal.getJournal();
    return r;
  } else {
    return new LifetimeSingleResultError('intermittent parameters not set ', '', journal.getJournal());
  }
};

/**
 * calculates the lifetime in hours for a linear movement
 */
const lifetimeSingleLinear = (body, dryWearData) => {
  var _body, _body$unitSystem, _body$materialDetails, _body$materialDetails2, _body$materialDetails3, _body$materialDetails4, _body$materialDetails5;
  const journal = new TrsExplanationJournal();
  const lifetimeParameters = {};
  journal.addTrsLifetimeIntro('lifetimeSingleLinear()', body, false);
  (_body$unitSystem = (_body = body).unitSystem) != null ? _body$unitSystem : _body.unitSystem = UnitSystem.metric;
  const {
    explanation,
    value
  } = adjustUnitSystemInRequestToMetric(body);
  journal.addText(explanation);
  body = value;
  const surfacePressure = getSurfacePressure(body.load);
  journal.addHeadline('basic parameter validation:');
  const checkResult = checkValues([
  // The values are in metric already, so it's needed to use the proper unit system
  ...getCommonCheckRows(surfacePressure, _extends({}, body, {
    unitSystem: UnitSystem.metric
  })), ...getLinParameterCheckRows(body.linearStrokeLength, body.linearFrequency, ((_body$materialDetails = body.materialDetails) == null ? void 0 : _body$materialDetails.maxLinearSpeed) || 0)]);
  journal.addText(checkResult.explanation);
  if (checkResult.value > 0) {
    const errorText = checkResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    return new LifetimeSingleResultError(errorText, body.igusMaterialId, journal.getJournal());
  }
  journal.addHeadline('material dependent parameter validation:');
  const checkIgusMaterialRows = [{
    key: 'surfacePressure',
    value: surfacePressure,
    unit: 'MPa',
    max: (_body$materialDetails2 = body.materialDetails) == null ? void 0 : _body$materialDetails2.maxSurfacePressure
  }, {
    key: 'temperature',
    value: body.temperature,
    unit: '°C',
    min: (_body$materialDetails3 = body.materialDetails) == null ? void 0 : _body$materialDetails3.minTemperature,
    max: (_body$materialDetails4 = body.materialDetails) == null ? void 0 : _body$materialDetails4.maxTemperature
  }];
  lifetimeParameters.surfacePressure = surfacePressure;
  const checkMaterialResult = checkValues(checkIgusMaterialRows);
  journal.addText(checkMaterialResult.explanation);
  if (checkMaterialResult.value > 0) {
    const errorText = checkMaterialResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    return new LifetimeSingleResultError(errorText, body.igusMaterialId, journal.getJournal());
  }
  journal.addHeadline('calculation:');
  let intermittentFactorsResult = {
    pvFactor: 1,
    vFactor: 1,
    explanation: 'fallback'
  };
  let intermittentRatio = 1;
  if (body.intermittentParams && body.intermittentParams.onTime > 0) {
    const res = calcLogIntermittentFactors(body);
    if (res.error) {
      return res;
    } else {
      intermittentFactorsResult = res;
      intermittentRatio = body.intermittentParams.onTime / (body.intermittentParams.onTime + body.intermittentParams.offTime);
    }
    journal.addText(intermittentFactorsResult.explanation);
  }
  const timeSliceFactorResult = calcTimeSliceFactor(body.activityMinutesPerHour);
  journal.addSubText(timeSliceFactorResult.explanation);
  const linearVelocityResult = calcLinearVelocity(timeSliceFactorResult.value, body.linearStrokeLength, body.linearFrequency);
  journal.addSubText(linearVelocityResult.explanation);
  const velocityMPS = linearVelocityResult.value / 3600;
  lifetimeParameters.linearVelocity = velocityMPS;
  journal.addKeyValue('', trunc3(velocityMPS), 'm/s');
  journal.addLinebreak();
  const effVelocityMPSResult = calcLogEffectiveIntermittentVelocity(velocityMPS, intermittentFactorsResult.vFactor);
  journal.addSubText(effVelocityMPSResult.explanation);
  journal.addHeadline('max velocity validation:');
  const checkMaxVelocityResult = checkValues([{
    key: 'velocity',
    value: trunc3(effVelocityMPSResult.value),
    unit: 'm/s',
    max: ((_body$materialDetails5 = body.materialDetails) == null ? void 0 : _body$materialDetails5.maxLinearSpeed) || 0
  }]);
  journal.addText(checkMaxVelocityResult.explanation);
  if (checkMaxVelocityResult.value > 0) {
    return new LifetimeSingleResultError('\nError - Veloctiy to high. Calculation stopped!', body.igusMaterialId, journal.getJournal());
  }
  const wearResult = calculateWearWithChecks(_extends({}, body, {
    spatialTypeOfMovementSingle: SpatialTypeOfMovementSingle.linear,
    surfacePressure,
    velocity: velocityMPS
  }), dryWearData);
  if (isWearErrorResult(wearResult)) {
    const errorMsg = 'Error - wearResult is not valid : ';
    journal.addKeyValue('error', errorMsg);
    journal.addKeyValue('cause', wearResult.error);
    return new LifetimeSingleResultError(errorMsg + wearResult.error, body.igusMaterialId, journal.getJournal());
  } else {
    if (!wearResult.success.value) {
      return new LifetimeSingleResultError('Error - wearValue is 0', body.igusMaterialId, journal.getJournal());
    }
    journal.addSubText(wearResult.success.explanation);
    lifetimeParameters.wear = wearResult.success.value;
  }
  const wearPerHourResult = calcWearPerHour(linearVelocityResult.value, intermittentRatio, wearResult.success.value);
  journal.addSubText(wearPerHourResult.explanation);
  const lifetimeResult = calcLifetime(body.acceptableWear, wearPerHourResult.value);
  journal.addSubText(lifetimeResult.explanation);
  const resultingMue = calcCoefficientOfFriction(body.igusMaterialId, surfacePressure);
  journal.addSubText(resultingMue.explanation);
  if (body.pvCalculationParams) {
    const checkPvResult = calcLogPvValues(resultingMue, body.temperature, surfacePressure, linearVelocityResult.value, body.materialDetails, body.oppositeMaterialId, body.pvCalculationParams, intermittentFactorsResult.pvFactor);
    journal.addText(checkPvResult.explanation);
    lifetimeParameters.pressureVelocity = _extends({}, checkPvResult.parameters);
    if (checkPvResult.value === 1) {
      const errorText = 'allowed PV max  can not be calculated';
      journal.addText(errorText);
    } else if (checkPvResult.value === 2) {
      return new LifetimeSingleResultError('', body.igusMaterialId, journal.getJournal());
    }
  }
  const serviceLifeResult = calcServiceLife(body.acceptableWear, wearResult.success.value);
  journal.addSubText(serviceLifeResult.explanation);
  lifetimeParameters.travelDistance = serviceLifeResult.value;
  journal.addHeadline('result:');
  journal.addTrsResultKeyValue('wear', wearResult.success);
  journal.addTrsResultKeyValue('timeSliceFactor', timeSliceFactorResult);
  journal.addKeyValue('effLinearVelocity', effVelocityMPSResult.value * 3600, 'm/h');
  const {
    explanation: resultExplanation,
    value: result
  } = adjustUnitSystemForResponseToImperial({
    lifetime: lifetimeResult.value,
    velocity: effVelocityMPSResult.value * 3600,
    wearPerHour: wearPerHourResult.value
  }, body.unitSystem);
  journal.addText(resultExplanation);
  return new LifetimeSingleResultSuccess(body.igusMaterialId, result.lifetime, result.velocity, result.wearPerHour, body.wantExplanation ? journal.getJournal() : undefined, lifetimeParameters);
};

/**
 * calculates the lifetime in hours for a pivoting movement
 */
const lifetimeSinglePivoting = (body, dryWearData) => {
  var _body, _body$unitSystem, _body$materialDetails, _body$materialDetails2, _body$materialDetails3, _body$materialDetails4, _body$materialDetails5;
  const journal = new TrsExplanationJournal();
  const lifetimeParameters = {};
  journal.addTrsLifetimeIntro('lifetimeSinglePivoting()', body, false);
  (_body$unitSystem = (_body = body).unitSystem) != null ? _body$unitSystem : _body.unitSystem = UnitSystem.metric;
  const {
    explanation,
    value
  } = adjustUnitSystemInRequestToMetric(body);
  journal.addText(explanation);
  body = value;
  const surfacePressure = getSurfacePressure(body.load);
  journal.addHeadline('basic parameter validation:');
  const checkResult = checkValues([
  // The values are in metric already so it's needed to use the proper unit system
  ...getCommonCheckRows(surfacePressure, _extends({}, body, {
    unitSystem: UnitSystem.metric
  })), ...getPivCheckRows(body.bearingInnerDiameter, body.pivotingAngle, body.pivotingFrequency, ((_body$materialDetails = body.materialDetails) == null ? void 0 : _body$materialDetails.maxPivotSpeed) || 0)]);
  journal.addText(checkResult.explanation);
  if (checkResult.value > 0) {
    const errorText = checkResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    return new LifetimeSingleResultError(errorText, body.igusMaterialId, journal.getJournal());
  }
  journal.addHeadline('material dependent parameter validation:');
  const checkIgusMaterialRows = [{
    key: 'surfacePressure',
    value: surfacePressure,
    unit: 'MPa',
    max: (_body$materialDetails2 = body.materialDetails) == null ? void 0 : _body$materialDetails2.maxSurfacePressure
  }, {
    key: 'temperature',
    value: body.temperature,
    unit: '°C',
    min: (_body$materialDetails3 = body.materialDetails) == null ? void 0 : _body$materialDetails3.minTemperature,
    max: (_body$materialDetails4 = body.materialDetails) == null ? void 0 : _body$materialDetails4.maxTemperature
  }];
  lifetimeParameters.surfacePressure = surfacePressure;
  const checkMaterialResult = checkValues(checkIgusMaterialRows);
  journal.addText(checkMaterialResult.explanation);
  if (checkMaterialResult.value > 0) {
    const errorText = checkMaterialResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    return new LifetimeSingleResultError(errorText, body.igusMaterialId, journal.getJournal());
  }
  journal.addHeadline('calculation:');
  let intermittentFactorsResult = {
    pvFactor: 1,
    vFactor: 1,
    explanation: 'fallback'
  };
  let intermittentRatio = 1;
  if (body.intermittentParams && body.intermittentParams.onTime > 0) {
    const res = calcLogIntermittentFactors(body);
    if (res.error) {
      return res;
    } else {
      intermittentFactorsResult = res;
      intermittentRatio = body.intermittentParams.onTime / (body.intermittentParams.onTime + body.intermittentParams.offTime);
    }
    journal.addText(intermittentFactorsResult.explanation);
  }
  const timeSliceFactorResult = calcTimeSliceFactor(body.activityMinutesPerHour);
  journal.addSubText(timeSliceFactorResult.explanation);
  const circumferenceResult = calcCircumference(body.bearingInnerDiameter);
  journal.addSubText(circumferenceResult.explanation);
  const pivVelocityResult = calcPivotingVelocity(timeSliceFactorResult.value, body.pivotingAngle, circumferenceResult.value, body.pivotingFrequency);
  lifetimeParameters.pivotingVelocity = pivVelocityResult.value;
  journal.addSubText(pivVelocityResult.explanation);
  const velocityMPS = pivVelocityResult.value / 3600;
  journal.addKeyValue('', trunc3(velocityMPS), 'm/s');
  journal.addLinebreak();
  const effVelocityMPSResult = calcLogEffectiveIntermittentVelocity(velocityMPS, intermittentFactorsResult.vFactor);
  journal.addSubText(effVelocityMPSResult.explanation);
  journal.addHeadline('max velocity validation:');
  const checkMaxVelocityResult = checkValues([{
    key: 'velocity',
    value: trunc3(effVelocityMPSResult.value),
    unit: 'm/s',
    max: ((_body$materialDetails5 = body.materialDetails) == null ? void 0 : _body$materialDetails5.maxPivotSpeed) || 0
  }]);
  journal.addText(checkMaxVelocityResult.explanation);
  if (checkMaxVelocityResult.value > 0) {
    return new LifetimeSingleResultError('\nError - Veloctiy to high. Calculation stopped!', body.igusMaterialId, journal.getJournal());
  }
  const wearResult = calculateWearWithChecks(_extends({}, body, {
    spatialTypeOfMovementSingle: SpatialTypeOfMovementSingle.pivoting,
    surfacePressure,
    velocity: velocityMPS
  }), dryWearData);
  if (isWearErrorResult(wearResult)) {
    const errorMsg = 'Error - wearResult is not valid : ';
    journal.addKeyValue('error', errorMsg);
    journal.addKeyValue('cause', wearResult.error);
    return new LifetimeSingleResultError(errorMsg + wearResult.error, body.igusMaterialId, journal.getJournal());
  } else {
    if (!wearResult.success.value) {
      return new LifetimeSingleResultError('Error - wearValue is 0', body.igusMaterialId, journal.getJournal());
    }
    journal.addSubText(wearResult.success.explanation);
    lifetimeParameters.wear = wearResult.success.value;
  }
  const wearPerHourResult = calcWearPerHour(pivVelocityResult.value, intermittentRatio, wearResult.success.value);
  journal.addSubText(wearPerHourResult.explanation);
  const lifetimeResult = calcLifetime(body.acceptableWear, wearPerHourResult.value);
  journal.addSubText(lifetimeResult.explanation);
  const resultingMue = calcCoefficientOfFriction(body.igusMaterialId, surfacePressure);
  journal.addSubText(resultingMue.explanation);
  if (body.pvCalculationParams) {
    const checkPvResult = calcLogPvValues(resultingMue, body.temperature, surfacePressure, pivVelocityResult.value, body.materialDetails, body.oppositeMaterialId, body.pvCalculationParams, intermittentFactorsResult.pvFactor);
    journal.addText(checkPvResult.explanation);
    lifetimeParameters.pressureVelocity = _extends({}, checkPvResult.parameters);
    if (checkPvResult.value === 1) {
      const errorText = 'allowed PV max  can not be calculated';
      journal.addText(errorText);
    } else if (checkPvResult.value === 2) {
      return new LifetimeSingleResultError('', body.igusMaterialId, journal.getJournal());
    }
  }
  const serviceLifeResult = calcServiceLife(body.acceptableWear, wearResult.success.value);
  journal.addSubText(serviceLifeResult.explanation);
  lifetimeParameters.travelDistance = serviceLifeResult.value;
  journal.addHeadline('result:');
  journal.addTrsResultKeyValue('wear', wearResult.success);
  journal.addTrsResultKeyValue('timeSliceFactor', timeSliceFactorResult);
  journal.addTrsResultKeyValue('circumference', circumferenceResult);
  journal.addKeyValue('effLinearVelocity', effVelocityMPSResult.value * 3600, 'm/h');
  const {
    explanation: resultExplanation,
    value: result
  } = adjustUnitSystemForResponseToImperial({
    lifetime: lifetimeResult.value,
    velocity: effVelocityMPSResult.value * 3600,
    wearPerHour: wearPerHourResult.value
  }, body.unitSystem);
  journal.addText(resultExplanation);
  return new LifetimeSingleResultSuccess(body.igusMaterialId, result.lifetime, result.velocity, result.wearPerHour, body.wantExplanation ? journal.getJournal() : undefined, lifetimeParameters);
};

/**
 * calculates the lifetime in hours for a simultaneous linear and pivoting movement
 */
const lifetimeSingleLinearAndPivotingSimultaneous = (body, dryWearData) => {
  var _body, _body$unitSystem, _body$materialDetails, _body$materialDetails2, _linearResult$lifetim, _pivotingResult$lifet;
  const journal = new TrsExplanationJournal();
  const lifetimeParameters = {};
  journal.addTrsLifetimeIntro('calculateLinearAndPivotingSimultaneousLifetime()', body, true);
  (_body$unitSystem = (_body = body).unitSystem) != null ? _body$unitSystem : _body.unitSystem = UnitSystem.metric;
  const {
    explanation,
    value
  } = adjustUnitSystemInRequestToMetric(body);
  journal.addText(explanation);
  body = value;
  const surfacePressure = getSurfacePressure(body.load);
  lifetimeParameters.surfacePressure = surfacePressure;
  journal.addHeadline('basic parameter validation:');
  const checkResult = checkValues([
  // The values are in metric already so it's needed to use the proper unit system
  ...getCommonCheckRows(surfacePressure, _extends({}, body, {
    unitSystem: UnitSystem.metric
  })), ...getLinParameterCheckRows(body.linearStrokeLength, body.linearFrequency, ((_body$materialDetails = body.materialDetails) == null ? void 0 : _body$materialDetails.maxLinearSpeed) || 0), ...getPivCheckRows(body.bearingInnerDiameter, body.pivotingAngle, body.pivotingFrequency, ((_body$materialDetails2 = body.materialDetails) == null ? void 0 : _body$materialDetails2.maxPivotSpeed) || 0)]);
  journal.addText(checkResult.explanation);
  if (checkResult.value > 0) {
    const errorText = checkResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    return new LifetimeSingleResultError(errorText, body.igusMaterialId, journal.getJournal());
  }
  const linearResult = lifetimeSingleLinear(_extends({}, body, {
    wantExplanation: false,
    unitSystem: UnitSystem.metric
  }), dryWearData);
  journal.addSubText(linearResult.explanation);
  if (linearResult.isError()) {
    return new LifetimeSingleResultError('linearResult error ' + linearResult.error, body.igusMaterialId, journal.getJournal());
  }
  lifetimeParameters.linearVelocity = linearResult == null || (_linearResult$lifetim = linearResult.lifetimeParameters) == null ? void 0 : _linearResult$lifetim.linearVelocity;
  const pivotingResult = lifetimeSinglePivoting(_extends({}, body, {
    wantExplanation: false,
    unitSystem: UnitSystem.metric
  }), dryWearData);
  journal.addSubText(pivotingResult.explanation);
  if (pivotingResult.isError()) {
    return new LifetimeSingleResultError('pivotingResult error ' + pivotingResult.error, body.igusMaterialId, journal.getJournal());
  }
  lifetimeParameters.pivotingVelocity = (_pivotingResult$lifet = pivotingResult.lifetimeParameters) == null ? void 0 : _pivotingResult$lifet.pivotingVelocity;
  let intermittentFactorsResult = {
    pvFactor: 1,
    explanation: 'fallback'
  };
  let intermittentRatio = 1;
  if (body.intermittentParams && body.intermittentParams.onTime > 0) {
    const res = calcLogIntermittentFactors(body);
    if (res.error) {
      return res;
    } else {
      intermittentFactorsResult = res;
      intermittentRatio = body.intermittentParams.onTime / (body.intermittentParams.onTime + body.intermittentParams.offTime);
    }
    journal.addText(intermittentFactorsResult.explanation);
  }
  const simWearPerHourResult = calcWearPerHourSimultaneous(linearResult.wearPerHour, pivotingResult.wearPerHour, 'linear', 'pivoting', intermittentRatio);
  journal.addSubText(simWearPerHourResult.explanation);
  const lifetimeResult = calcLifetime(body.acceptableWear, simWearPerHourResult.value);
  journal.addSubText(lifetimeResult.explanation);
  const simVelocityResult = calcVelocitySimultaneous(linearResult.velocity, pivotingResult.velocity, 'linear', 'pivoting');
  journal.addSubText(simVelocityResult.explanation);
  const resultingMue = calcCoefficientOfFriction(body.igusMaterialId, surfacePressure);
  journal.addSubText(resultingMue.explanation);
  if (body.pvCalculationParams) {
    const checkPvResult = calcLogPvValues(resultingMue, body.temperature, surfacePressure, simVelocityResult.value, body.materialDetails, body.oppositeMaterialId, body.pvCalculationParams, intermittentFactorsResult.pvFactor);
    journal.addText(checkPvResult.explanation);
    lifetimeParameters.pressureVelocity = _extends({}, checkPvResult.parameters);
    if (checkPvResult.value === 1) {
      const errorText = 'allowed PV max  can not be calculated';
      journal.addText(errorText);
    } else if (checkPvResult.value === 2) {
      return new LifetimeSingleResultError('', body.igusMaterialId, journal.getJournal());
    }
  }
  const {
    explanation: resultExplanation,
    value: result
  } = adjustUnitSystemForResponseToImperial({
    lifetime: lifetimeResult.value,
    velocity: simVelocityResult.value * 3600,
    wearPerHour: simWearPerHourResult.value
  }, body.unitSystem);
  journal.addText(resultExplanation);
  return new LifetimeSingleResultSuccess(body.igusMaterialId, result.lifetime, result.velocity, result.wearPerHour, body.wantExplanation ? journal.getJournal() : undefined, lifetimeParameters);
};
/**
 * calculates the lifetime in hours for a sequential linear and pivoting movement
 */
const lifetimeSingleLinearAndPivotingSequential = (body, temporalLinearPart, dryWear) => {
  var _body2, _body2$unitSystem, _body$materialDetails3, _body$materialDetails4, _linearResult$lifetim2, _pivotingResult$lifet2;
  const journal = new TrsExplanationJournal();
  journal.addTrsLifetimeIntro('calculateLinearAndPivotingSequentialLifetime()', body, true);
  (_body2$unitSystem = (_body2 = body).unitSystem) != null ? _body2$unitSystem : _body2.unitSystem = UnitSystem.metric;
  const toMetricCall = adjustUnitSystemInRequestToMetric(body);
  journal.addText(toMetricCall.explanation);
  body = toMetricCall.value;
  journal.addText('\ntemporal parameters:');
  journal.addKeyValue('temporalLinearPart', temporalLinearPart);
  const surfacePressure = getSurfacePressure(body.load);
  journal.addHeadline('basic parameter validation:');
  const checkResult = checkValues([
  // The values are in metric already so it's needed to use the proper unit system
  ...getCommonCheckRows(surfacePressure, _extends({}, body, {
    unitSystem: UnitSystem.metric
  })), ...getLinParameterCheckRows(body.linearStrokeLength, body.linearFrequency, ((_body$materialDetails3 = body.materialDetails) == null ? void 0 : _body$materialDetails3.maxLinearSpeed) || 0), ...getPivCheckRows(body.bearingInnerDiameter, body.pivotingAngle, body.pivotingFrequency, ((_body$materialDetails4 = body.materialDetails) == null ? void 0 : _body$materialDetails4.maxPivotSpeed) || 0)]);
  journal.addText(checkResult.explanation);
  if (checkResult.value > 0) {
    const errorText = checkResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    return new LifetimeSingleResultError(errorText, body.igusMaterialId, journal.getJournal());
  }
  const linearResult = lifetimeSingleLinear(_extends({}, body, {
    wantExplanation: false,
    unitSystem: UnitSystem.metric
  }), dryWear);
  journal.addSubText(linearResult.explanation);
  if (linearResult.isError()) {
    return new LifetimeSingleResultError('linearResult error ' + linearResult.error, body.igusMaterialId, journal.getJournal());
  }
  linearResult == null || (_linearResult$lifetim2 = linearResult.lifetimeParameters) == null ? void 0 : _linearResult$lifetim2.linearVelocity;
  const pivotingResult = lifetimeSinglePivoting(_extends({}, body, {
    wantExplanation: false,
    unitSystem: UnitSystem.metric
  }), dryWear);
  journal.addSubText(pivotingResult.explanation);
  if (pivotingResult.isError()) {
    return new LifetimeSingleResultError('pivotingResult error ' + pivotingResult.error, body.igusMaterialId, journal.getJournal());
  }
  pivotingResult == null || (_pivotingResult$lifet2 = pivotingResult.lifetimeParameters) == null ? void 0 : _pivotingResult$lifet2.pivotingVelocity;
  const temporalPivotingPartResult = calcTemporalPivotingPart(temporalLinearPart);
  journal.addSubText(temporalPivotingPartResult.explanation);
  let intermittentFactorsResult = {
    pvFactor: 1,
    explanation: 'fallback'
  };
  let intermittentRatio = 1;
  if (body.intermittentParams && body.intermittentParams.onTime > 0) {
    const res = calcLogIntermittentFactors(body);
    if (res.error) {
      return res;
    } else {
      intermittentFactorsResult = res;
      intermittentRatio = body.intermittentParams.onTime / (body.intermittentParams.onTime + body.intermittentParams.offTime);
    }
    journal.addText(intermittentFactorsResult.explanation);
  }
  const seqWearPerHourResult = calcWearPerHourSequential(linearResult.wearPerHour, pivotingResult.wearPerHour, 'linear', 'pivoting', temporalLinearPart, temporalPivotingPartResult.value, intermittentRatio);
  journal.addSubText(seqWearPerHourResult.explanation);
  const lifetimeResult = calcLifetime(body.acceptableWear, seqWearPerHourResult.value);
  journal.addSubText(lifetimeResult.explanation);
  const seqVelocityResult = calcVelocitySequential(linearResult.velocity, pivotingResult.velocity, 'linear', 'pivoting');
  journal.addSubText(seqVelocityResult.explanation);
  const resultingMue = calcCoefficientOfFriction(body.igusMaterialId, surfacePressure);
  journal.addSubText(resultingMue.explanation);
  if (body.pvCalculationParams) {
    const checkPvResult = calcLogPvValues(resultingMue, body.temperature, surfacePressure, seqVelocityResult.value, body.materialDetails, body.oppositeMaterialId, body.pvCalculationParams, intermittentFactorsResult.pvFactor);
    journal.addText(checkPvResult.explanation);
    _extends({}, checkPvResult.parameters);
    if (checkPvResult.value === 1) {
      const errorText = 'allowed PV max  can not be calculated';
      journal.addText(errorText);
    } else if (checkPvResult.value === 2) {
      return new LifetimeSingleResultError('', body.igusMaterialId, journal.getJournal());
    }
  }
  const {
    explanation: resultExplanation,
    value: result
  } = adjustUnitSystemForResponseToImperial({
    lifetime: lifetimeResult.value,
    velocity: seqVelocityResult.value,
    wearPerHour: seqWearPerHourResult.value
  }, body.unitSystem);
  journal.addText(resultExplanation);
  return new LifetimeSingleResultSuccess(body.igusMaterialId, result.lifetime, result.velocity, result.wearPerHour, body.wantExplanation ? journal.getJournal() : undefined);
};

/**
 * calculates the lifetime in hours for a rotation movement
 */
const lifetimeSingleRotation = (body, dryWearData) => {
  var _body, _body$unitSystem, _body$materialDetails, _body$materialDetails2, _body$materialDetails3, _body$materialDetails4, _body$materialDetails5;
  const journal = new TrsExplanationJournal();
  const lifetimeParameters = {};
  journal.addTrsLifetimeIntro('lifetimeSingleRotation()', body, false);
  (_body$unitSystem = (_body = body).unitSystem) != null ? _body$unitSystem : _body.unitSystem = UnitSystem.metric;
  const {
    explanation,
    value
  } = adjustUnitSystemInRequestToMetric(body);
  journal.addText(explanation);
  body = value;
  const surfacePressure = getSurfacePressure(body.load);
  lifetimeParameters.surfacePressure = surfacePressure;
  journal.addHeadline('basic parameter validation:');
  const checkResult = checkValues([
  // The values are in metric already so it's needed to use the proper unit system
  ...getCommonCheckRows(surfacePressure, _extends({}, body, {
    unitSystem: UnitSystem.metric
  })), ...getRotParameterCheckRows(body.bearingInnerDiameter, body.rotationRevolutions, ((_body$materialDetails = body.materialDetails) == null ? void 0 : _body$materialDetails.maxRotationalSpeed) || 0)]);
  journal.addText(checkResult.explanation);
  if (checkResult.value > 0) {
    const errorText = checkResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    return new LifetimeSingleResultError(errorText, body.igusMaterialId, journal.getJournal());
  }
  journal.addHeadline('material dependent parameter validation:');
  const checkIgusMaterialRows = [{
    key: 'surfacePressure',
    value: surfacePressure,
    unit: 'MPa',
    max: (_body$materialDetails2 = body.materialDetails) == null ? void 0 : _body$materialDetails2.maxSurfacePressure
  }, {
    key: 'temperature',
    value: body.temperature,
    unit: '°C',
    min: (_body$materialDetails3 = body.materialDetails) == null ? void 0 : _body$materialDetails3.minTemperature,
    max: (_body$materialDetails4 = body.materialDetails) == null ? void 0 : _body$materialDetails4.maxTemperature
  }];
  const checkMaterialResult = checkValues(checkIgusMaterialRows);
  journal.addText(checkMaterialResult.explanation);
  if (checkMaterialResult.value > 0) {
    const errorText = checkMaterialResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    return new LifetimeSingleResultError(errorText, body.igusMaterialId, journal.getJournal());
  }
  journal.addHeadline('calculation:');
  let intermittentFactorsResult = {
    pvFactor: 1,
    vFactor: 1,
    explanation: 'fallback'
  };
  let intermittentRatio = 1;
  if (body.intermittentParams && body.intermittentParams.onTime > 0) {
    const res = calcLogIntermittentFactors(body);
    if (res.error) {
      return res;
    } else {
      intermittentFactorsResult = res;
      intermittentRatio = body.intermittentParams.onTime / (body.intermittentParams.onTime + body.intermittentParams.offTime);
    }
    journal.addText(intermittentFactorsResult.explanation);
  }
  const timeSliceFactorResult = calcTimeSliceFactor(body.activityMinutesPerHour);
  journal.addSubText(timeSliceFactorResult.explanation);
  const circumferenceResult = calcCircumference(body.bearingInnerDiameter);
  journal.addSubText(circumferenceResult.explanation);
  const rotationVelocityResult = calcRotationVelocity(timeSliceFactorResult.value, body.rotationRevolutions, circumferenceResult.value);
  journal.addSubText(rotationVelocityResult.explanation);
  const velocityMPS = rotationVelocityResult.value / 3600;
  journal.addKeyValue('', trunc3(velocityMPS), 'm/s');
  journal.addLinebreak();
  const effVelocityMPSResult = calcLogEffectiveIntermittentVelocity(velocityMPS, intermittentFactorsResult.vFactor);
  journal.addSubText(effVelocityMPSResult.explanation);
  journal.addHeadline('max velocity validation:');
  const checkMaxVelocityResult = checkValues([{
    key: 'velocity',
    value: trunc3(effVelocityMPSResult.value),
    unit: 'm/s',
    max: ((_body$materialDetails5 = body.materialDetails) == null ? void 0 : _body$materialDetails5.maxRotationalSpeed) || 0
  }]);
  lifetimeParameters.rotationalSpeed = effVelocityMPSResult.value;
  journal.addText(checkMaxVelocityResult.explanation);
  if (checkMaxVelocityResult.value > 0) {
    return new LifetimeSingleResultError('\nError - Velocity to high. Calculation stopped!', body.igusMaterialId, journal.getJournal());
  }
  const wearResult = calculateWearWithChecks(_extends({}, body, {
    spatialTypeOfMovementSingle: SpatialTypeOfMovementSingle.rotation,
    surfacePressure,
    velocity: velocityMPS
  }), dryWearData);
  if (isWearErrorResult(wearResult)) {
    const errorMsg = 'Error - wearResult is not valid : ';
    journal.addKeyValue('error', errorMsg);
    journal.addKeyValue('cause', wearResult.error);
    return new LifetimeSingleResultError(errorMsg + wearResult.error, body.igusMaterialId, journal.getJournal());
  } else {
    if (!wearResult.success.value) {
      return new LifetimeSingleResultError('Error - wearValue is 0', body.igusMaterialId, journal.getJournal());
    }
    journal.addSubText(wearResult.success.explanation);
    lifetimeParameters.wear = wearResult.success.value;
  }
  const wearPerHourResult = calcWearPerHour(rotationVelocityResult.value, intermittentRatio, wearResult.success.value);
  journal.addSubText(wearPerHourResult.explanation);
  const lifetimeResult = calcLifetime(body.acceptableWear, wearPerHourResult.value);
  journal.addSubText(lifetimeResult.explanation);
  const resultingMue = calcCoefficientOfFriction(body.igusMaterialId, surfacePressure);
  journal.addSubText(resultingMue.explanation);
  if (body.pvCalculationParams) {
    const checkPvResult = calcLogPvValues(resultingMue, body.temperature, surfacePressure, rotationVelocityResult.value, body.materialDetails, body.oppositeMaterialId, body.pvCalculationParams, intermittentFactorsResult.pvFactor);
    journal.addText(checkPvResult.explanation);
    lifetimeParameters.pressureVelocity = _extends({}, checkPvResult.parameters);
    if (checkPvResult.value === 1) {
      const errorText = 'allowed PV max  can not be calculated';
      journal.addText(errorText);
    } else if (checkPvResult.value === 2) {
      return new LifetimeSingleResultError('', body.igusMaterialId, journal.getJournal());
    }
  }
  const serviceLifeResult = calcServiceLife(body.acceptableWear, wearResult.success.value);
  journal.addSubText(serviceLifeResult.explanation);
  lifetimeParameters.travelDistance = serviceLifeResult.value;
  journal.addHeadline('result:');
  journal.addTrsResultKeyValue('wear', wearResult.success);
  journal.addTrsResultKeyValue('timeSliceFactor', timeSliceFactorResult);
  journal.addTrsResultKeyValue('circumference', circumferenceResult);
  journal.addKeyValue('effLinearVelocity', effVelocityMPSResult.value * 3600, 'm/h');
  const {
    explanation: resultExplanation,
    value: result
  } = adjustUnitSystemForResponseToImperial({
    lifetime: lifetimeResult.value,
    velocity: effVelocityMPSResult.value * 3600,
    wearPerHour: wearPerHourResult.value
  }, body.unitSystem);
  journal.addText(resultExplanation);
  return new LifetimeSingleResultSuccess(body.igusMaterialId, result.lifetime, result.velocity, result.wearPerHour, body.wantExplanation ? journal.getJournal() : undefined, lifetimeParameters);
};

/**
 * calculates the lifetime in hours for a simultaneous linear and rotating movement
 *
 */
const lifetimeSingleLinearAndRotationalSimultaneous = (body, dryWearData) => {
  var _body, _body$unitSystem, _body$materialDetails, _body$materialDetails2, _linearResult$lifetim, _rotationResult$lifet;
  const journal = new TrsExplanationJournal();
  const lifetimeParameters = {};
  journal.addTrsLifetimeIntro('calculateLinearAndRotationalSimultaneousLifetime()', body, true);
  (_body$unitSystem = (_body = body).unitSystem) != null ? _body$unitSystem : _body.unitSystem = UnitSystem.metric;
  const {
    explanation,
    value
  } = adjustUnitSystemInRequestToMetric(body);
  journal.addText(explanation);
  body = value;
  const surfacePressure = getSurfacePressure(body.load);
  lifetimeParameters.surfacePressure = surfacePressure;
  journal.addHeadline('basic parameter validation:');
  const checkResult = checkValues([
  // The values are in metric already so it's needed to use the proper unit system
  ...getCommonCheckRows(surfacePressure, _extends({}, body, {
    unitSystem: UnitSystem.metric
  })), ...getLinParameterCheckRows(body.linearStrokeLength, body.linearFrequency, ((_body$materialDetails = body.materialDetails) == null ? void 0 : _body$materialDetails.maxLinearSpeed) || 0), ...getRotParameterCheckRows(body.bearingInnerDiameter, body.rotationRevolutions, ((_body$materialDetails2 = body.materialDetails) == null ? void 0 : _body$materialDetails2.maxRotationalSpeed) || 0)]);
  journal.addText(checkResult.explanation);
  if (checkResult.value > 0) {
    const errorText = checkResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    return new LifetimeSingleResultError(errorText, body.igusMaterialId, journal.getJournal());
  }
  const linearResult = lifetimeSingleLinear(_extends({}, body, {
    wantExplanation: false,
    unitSystem: UnitSystem.metric
  }), dryWearData);
  journal.addSubText(linearResult.explanation);
  if (linearResult.isError()) {
    return new LifetimeSingleResultError('linearResult error ' + linearResult.error, body.igusMaterialId, journal.getJournal());
  }
  lifetimeParameters.linearVelocity = linearResult == null || (_linearResult$lifetim = linearResult.lifetimeParameters) == null ? void 0 : _linearResult$lifetim.linearVelocity;
  const rotationResult = lifetimeSingleRotation(_extends({}, body, {
    wantExplanation: false,
    unitSystem: UnitSystem.metric
  }), dryWearData);
  journal.addSubText(rotationResult.explanation);
  if (rotationResult.isError()) {
    return new LifetimeSingleResultError('pivotingResult error ' + rotationResult.error, body.igusMaterialId, journal.getJournal());
  }
  lifetimeParameters.rotationalSpeed = rotationResult == null || (_rotationResult$lifet = rotationResult.lifetimeParameters) == null ? void 0 : _rotationResult$lifet.rotationalSpeed;
  let intermittentFactorsResult = {
    pvFactor: 1,
    explanation: 'fallback'
  };
  let intermittentRatio = 1;
  if (body.intermittentParams && body.intermittentParams.onTime > 0) {
    const res = calcLogIntermittentFactors(body);
    if (res.error) {
      return res;
    } else {
      intermittentFactorsResult = res;
      intermittentRatio = body.intermittentParams.onTime / (body.intermittentParams.onTime + body.intermittentParams.offTime);
    }
    journal.addText(intermittentFactorsResult.explanation);
  }
  const simWearPerHourResult = calcWearPerHourSimultaneous(linearResult.wearPerHour, rotationResult.wearPerHour, 'linear', 'rotation', intermittentRatio);
  journal.addSubText(simWearPerHourResult.explanation);
  lifetimeParameters.wear = simWearPerHourResult.value;
  const lifetimeResult = calcLifetime(body.acceptableWear, simWearPerHourResult.value);
  journal.addSubText(lifetimeResult.explanation);
  const simVelocityResult = calcVelocitySimultaneous(linearResult.velocity, rotationResult.velocity, 'linear', 'rotation');
  journal.addSubText(simVelocityResult.explanation);
  const resultingMue = calcCoefficientOfFriction(body.igusMaterialId, surfacePressure);
  journal.addSubText(resultingMue.explanation);
  if (body.pvCalculationParams) {
    const checkPvResult = calcLogPvValues(resultingMue, body.temperature, surfacePressure, simVelocityResult.value, body.materialDetails, body.oppositeMaterialId, body.pvCalculationParams, intermittentFactorsResult.pvFactor);
    journal.addText(checkPvResult.explanation);
    lifetimeParameters.pressureVelocity = _extends({}, checkPvResult.parameters);
    if (checkPvResult.value === 1) {
      const errorText = 'allowed PV max  can not be calculated';
      journal.addText(errorText);
    } else if (checkPvResult.value === 2) {
      return new LifetimeSingleResultError('', body.igusMaterialId, journal.getJournal());
    }
  }
  const {
    explanation: resultExplanation,
    value: result
  } = adjustUnitSystemForResponseToImperial({
    lifetime: lifetimeResult.value,
    velocity: simVelocityResult.value * 3600,
    wearPerHour: simWearPerHourResult.value
  }, body.unitSystem);
  journal.addText(resultExplanation);
  return new LifetimeSingleResultSuccess(body.igusMaterialId, result.lifetime, result.velocity, result.wearPerHour, body.wantExplanation ? journal.getJournal() : undefined, lifetimeParameters);
};
/**
 * calculates the lifetime in hours for a sequential linear and rotating movement
 */
const lifetimeSingleLinearAndRotationalSequential = (body, temporalLinearPart, dryWearData) => {
  var _body2, _body2$unitSystem, _body$materialDetails3, _body$materialDetails4, _linearResult$lifetim2, _rotationResult$lifet2;
  const journal = new TrsExplanationJournal();
  const lifetimeParameters = {};
  journal.addTrsLifetimeIntro('calculateLinearAndRotationalSequentialLifetime()', body, true);
  (_body2$unitSystem = (_body2 = body).unitSystem) != null ? _body2$unitSystem : _body2.unitSystem = UnitSystem.metric;
  const toMetricCall = adjustUnitSystemInRequestToMetric(body);
  journal.addText(toMetricCall.explanation);
  body = toMetricCall.value;
  journal.addText('\ntemporal parameters:');
  journal.addKeyValue('temporalLinearPart', temporalLinearPart);
  const surfacePressure = getSurfacePressure(body.load);
  lifetimeParameters.surfacePressure = surfacePressure;
  journal.addHeadline('basic parameter validation:');
  const checkResult = checkValues([
  // The values are in metric already so it's needed to use the proper unit system
  ...getCommonCheckRows(surfacePressure, _extends({}, body, {
    unitSystem: UnitSystem.metric
  })), ...getLinParameterCheckRows(body.linearStrokeLength, body.linearFrequency, ((_body$materialDetails3 = body.materialDetails) == null ? void 0 : _body$materialDetails3.maxLinearSpeed) || 0), ...getRotParameterCheckRows(body.bearingInnerDiameter, body.rotationRevolutions, ((_body$materialDetails4 = body.materialDetails) == null ? void 0 : _body$materialDetails4.maxRotationalSpeed) || 0)]);
  journal.addText(checkResult.explanation);
  if (checkResult.value > 0) {
    const errorText = checkResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    return new LifetimeSingleResultError(errorText, body.igusMaterialId, journal.getJournal());
  }
  const linearResult = lifetimeSingleLinear(_extends({}, body, {
    wantExplanation: false,
    unitSystem: UnitSystem.metric
  }), dryWearData);
  journal.addSubText(linearResult.explanation);
  if (linearResult.isError()) {
    return new LifetimeSingleResultError('linearResult error ' + linearResult.error, body.igusMaterialId, journal.getJournal());
  }
  lifetimeParameters.linearVelocity = linearResult == null || (_linearResult$lifetim2 = linearResult.lifetimeParameters) == null ? void 0 : _linearResult$lifetim2.linearVelocity;
  const rotationResult = lifetimeSingleRotation(_extends({}, body, {
    wantExplanation: false,
    unitSystem: UnitSystem.metric
  }), dryWearData);
  journal.addSubText(rotationResult.explanation);
  if (rotationResult.isError()) {
    return new LifetimeSingleResultError('pivotingResult error ' + rotationResult.error, body.igusMaterialId, journal.getJournal());
  }
  lifetimeParameters.rotationalSpeed = rotationResult == null || (_rotationResult$lifet2 = rotationResult.lifetimeParameters) == null ? void 0 : _rotationResult$lifet2.rotationalSpeed;
  const temporalPivotingPartResult = calcTemporalPivotingPart(temporalLinearPart);
  journal.addSubText(temporalPivotingPartResult.explanation);
  let intermittentFactorsResult = {
    pvFactor: 1,
    explanation: 'fallback'
  };
  let intermittentRatio = 1;
  if (body.intermittentParams && body.intermittentParams.onTime > 0) {
    const res = calcLogIntermittentFactors(body);
    if (res.error) {
      return res;
    } else {
      intermittentFactorsResult = res;
      intermittentRatio = body.intermittentParams.onTime / (body.intermittentParams.onTime + body.intermittentParams.offTime);
    }
    journal.addText(intermittentFactorsResult.explanation);
  }
  const seqWearPerHourResult = calcWearPerHourSequential(linearResult.wearPerHour, rotationResult.wearPerHour, 'linear', 'rotation', temporalLinearPart, temporalPivotingPartResult.value, intermittentRatio);
  journal.addSubText(seqWearPerHourResult.explanation);
  const lifetimeResult = calcLifetime(body.acceptableWear, seqWearPerHourResult.value);
  journal.addSubText(lifetimeResult.explanation);
  const seqVelocityResult = calcVelocitySequential(linearResult.velocity, rotationResult.velocity, 'linear', 'rotation');
  journal.addSubText(seqVelocityResult.explanation);
  const resultingMue = calcCoefficientOfFriction(body.igusMaterialId, surfacePressure);
  journal.addSubText(resultingMue.explanation);
  if (body.pvCalculationParams) {
    const checkPvResult = calcLogPvValues(resultingMue, body.temperature, surfacePressure, seqVelocityResult.value, body.materialDetails, body.oppositeMaterialId, body.pvCalculationParams, intermittentFactorsResult.pvFactor);
    journal.addText(checkPvResult.explanation);
    lifetimeParameters.pressureVelocity = _extends({}, checkPvResult.parameters);
    if (checkPvResult.value === 1) {
      const errorText = 'allowed PV max  can not be calculated';
      journal.addText(errorText);
    } else if (checkPvResult.value === 2) {
      return new LifetimeSingleResultError('', body.igusMaterialId, journal.getJournal());
    }
  }
  const {
    explanation: resultExplanation,
    value: result
  } = adjustUnitSystemForResponseToImperial({
    lifetime: lifetimeResult.value,
    velocity: seqVelocityResult.value,
    wearPerHour: seqWearPerHourResult.value
  }, body.unitSystem);
  journal.addText(resultExplanation);
  return new LifetimeSingleResultSuccess(body.igusMaterialId, result.lifetime, result.velocity, result.wearPerHour, body.wantExplanation ? journal.getJournal() : undefined, lifetimeParameters);
};

/**
 * Class to return Errors
 */
class LifetimeMultipleResultError {
  constructor(error, explanation) {
    this.error = error;
    this.explanation = explanation;
  }
  isError() {
    return true;
  }
  isSuccess() {
    return false;
  }
  getError() {
    return this.error;
  }
  getExplanation() {
    return this.explanation || '';
  }
  getPlain(wantExplanation) {
    if (wantExplanation && this.explanation) {
      return {
        error: this.error,
        explanation: this.explanation
      };
    } else {
      return {
        error: this.error
      };
    }
  }
}
/**
 * Class to return Success
 */
class LifetimeMultipleResultSuccess {
  constructor(list, explanation) {
    this.list = list;
    this.explanation = explanation;
  }
  getExplanation() {
    return this.explanation || '';
  }
  getList() {
    return this.list;
  }
  isError() {
    return false;
  }
  isSuccess() {
    return true;
  }
  getPlain(wantExplanation) {
    if (wantExplanation && this.explanation) {
      return {
        list: this.list,
        explanation: this.explanation
      };
    } else {
      return {
        list: this.list
      };
    }
  }
}

const _excluded$1 = ["explanation"];
const handleLifetimeMultipleSuccess$1 = (results, wantExplanation, journal) => {
  const simpleResults = results.sort((a, b) => a.isSuccess() && b.isSuccess() ? b.lifetime - a.lifetime : b.isSuccess() ? 1 : -1).map(_ref => {
    let {
        explanation
      } = _ref,
      lifetime = _objectWithoutPropertiesLoose(_ref, _excluded$1);
    return _extends({}, lifetime, {
      explanation: wantExplanation ? explanation : undefined
    });
  });
  return new LifetimeMultipleResultSuccess(simpleResults, wantExplanation ? journal.getJournal() : undefined);
};

/**
 * calculates the lifetime in hours for a linear movement for all igus koplaMaterial
 */
const lifetimeMaterialMultipleLinear = (body, dryWearData) => {
  const journal = new TrsExplanationJournal();
  journal.addTrsLifetimeIntro('lifetimeMaterialMultipleLinear()', body, false);
  const surfacePressure = getSurfacePressure(body.load);
  journal.addHeadline('basic parameter validation:');
  const checkResult = checkValues([...getCommonCheckRows(surfacePressure, body)]);
  journal.addText(checkResult.explanation);
  if (checkResult.value > 0) {
    const errorText = checkResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    return new LifetimeMultipleResultError(errorText, journal.getJournal());
  }
  journal.addText('\nlinear parameters:');
  journal.addKeyValue('strokeLength', body.linearStrokeLength, 'mm');
  journal.addKeyValue('linearFrequencyCountPerMinute', body.linearFrequency, '1/min');
  journal.addHeadline('calculation:');
  const list = body.materialDetails.map(material => lifetimeSingleLinear(_extends({}, body, {
    igusMaterialId: material.name,
    materialDetails: material
  }), dryWearData));
  return handleLifetimeMultipleSuccess$1(list, body.wantExplanation, journal);
};

/**
 * calculates the lifetime in hours for a rotation movement for all igus koplaMaterial
 *
 */
const lifetimeMaterialMultipleRotation = (body, dryWearData) => {
  const journal = new TrsExplanationJournal();
  journal.addTrsLifetimeIntro('lifetimeMaterialListRotation()', body, false);
  const surfacePressure = getSurfacePressure(body.load);
  journal.addHeadline('basic parameter validation:');
  const checkResult = checkValues([...getCommonCheckRows(surfacePressure, body)]);
  journal.addText(checkResult.explanation);
  if (checkResult.value > 0) {
    const errorText = checkResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    return new LifetimeMultipleResultError(errorText, journal.getJournal());
  }
  journal.addText('\nrotation parameters:');
  journal.addKeyValue('diameter', body.bearingInnerDiameter, 'mm');
  journal.addKeyValue('revolutionsPerMinute', body.rotationRevolutions, '1/min');
  const list = body.materialDetails.map(material => lifetimeSingleRotation(_extends({}, body, {
    igusMaterialId: material.name,
    materialDetails: material
  }), dryWearData));
  return handleLifetimeMultipleSuccess$1(list, body.wantExplanation, journal);
};

/**
 * calculates the lifetime in hours for a pivoting movement for all igus koplaMaterial
 */
const lifetimeMaterialMultiplePivoting = (body, dryWearData) => {
  const journal = new TrsExplanationJournal();
  journal.addTrsLifetimeIntro('lifetimeMaterialListPivoting()', body, false);
  const surfacePressure = getSurfacePressure(body.load);
  journal.addHeadline('basic parameter validation:');
  const checkResult = checkValues([...getCommonCheckRows(surfacePressure, body)]);
  journal.addText(checkResult.explanation);
  if (checkResult.value > 0) {
    const errorText = checkResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    return new LifetimeMultipleResultError(errorText, journal.getJournal());
  }
  journal.addText('\npivoting parameters:');
  journal.addKeyValue('diameter', body.bearingInnerDiameter, 'mm');
  journal.addKeyValue('pivotingAngle', body.pivotingAngle, '°');
  journal.addKeyValue('pivotingFrequencyCountPerMin', body.pivotingFrequency, '1/min');
  const list = body.materialDetails.map(material => lifetimeSinglePivoting(_extends({}, body, {
    igusMaterialId: material.name,
    materialDetails: material
  }), dryWearData));
  return handleLifetimeMultipleSuccess$1(list, body.wantExplanation, journal);
};

const lifetimeMaterialMultipleLinearAndPivotingSimultaneous = (body, dryWearData) => {
  const journal = new TrsExplanationJournal();
  journal.addTrsLifetimeIntro('lifetimeMaterialMultipleLinearAndPivoting()', body, false);
  const surfacePressure = getSurfacePressure(body.load);
  journal.addHeadline('basic parameter validation:');
  const checkResult = checkValues([...getCommonCheckRows(surfacePressure, body)]);
  journal.addText(checkResult.explanation);
  if (checkResult.value > 0) {
    const errorText = checkResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    return new LifetimeMultipleResultError(errorText, journal.getJournal());
  }
  journal.addText('\nlinear parameters:');
  journal.addKeyValue('strokeLength', body.linearStrokeLength, 'mm');
  journal.addKeyValue('linearFrequencyCountPerMinute', body.linearFrequency, '1/min');
  journal.addText('\npivoting parameters:');
  journal.addKeyValue('diameter', body.bearingInnerDiameter, 'mm');
  journal.addKeyValue('pivotingAngle', body.pivotingAngle, '°');
  journal.addKeyValue('pivotingFrequencyCountPerMin', body.pivotingFrequency, '1/min');
  const list = body.materialDetails.map(material => lifetimeSingleLinearAndPivotingSimultaneous(_extends({}, body, {
    igusMaterialId: material.name,
    materialDetails: material
  }), dryWearData));
  return handleLifetimeMultipleSuccess$1(list, body.wantExplanation, journal);
};
const lifetimeMaterialMultipleLinearAndPivotingSequential = (body, temporalLinearPart, dryWearData) => {
  const logger = new TrsExplanationJournal();
  logger.addTrsLifetimeIntro('lifetimeMaterialMultipleLinearAndPivoting()', body, false);
  const surfacePressure = getSurfacePressure(body.load);
  logger.addHeadline('basic parameter validation:');
  const checkResult = checkValues([...getCommonCheckRows(surfacePressure, body)]);
  logger.addText(checkResult.explanation);
  if (checkResult.value > 0) {
    const errorText = checkResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    return new LifetimeMultipleResultError(errorText, logger.getJournal());
  }
  logger.addText('\nlinear parameters:');
  logger.addKeyValue('strokeLength', body.linearStrokeLength, 'mm');
  logger.addKeyValue('linearFrequencyCountPerMinute', body.linearFrequency, '1/min');
  logger.addText('\npivoting parameters:');
  logger.addKeyValue('diameter', body.bearingInnerDiameter, 'mm');
  logger.addKeyValue('pivotingAngle', body.pivotingAngle, '°');
  logger.addKeyValue('pivotingFrequencyCountPerMin', body.pivotingFrequency, '1/min');
  const list = body.materialDetails.map(material => lifetimeSingleLinearAndPivotingSequential(_extends({}, body, {
    igusMaterialId: material.name,
    materialDetails: material
  }), temporalLinearPart, dryWearData));
  return handleLifetimeMultipleSuccess$1(list, body.wantExplanation, logger);
};

const lifetimeMaterialMultipleLinearAndRotationSimultaneous = (body, dryWearData) => {
  const journal = new TrsExplanationJournal();
  journal.addTrsLifetimeIntro('lifetimeMaterialMultipleLinearAndRotation()', body, false);
  const surfacePressure = getSurfacePressure(body.load);
  journal.addHeadline('basic parameter validation:');
  const checkResult = checkValues([...getCommonCheckRows(surfacePressure, body)]);
  journal.addText(checkResult.explanation);
  if (checkResult.value > 0) {
    const errorText = checkResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    return new LifetimeMultipleResultError(errorText, journal.getJournal());
  }
  journal.addText('\nlinear parameters:');
  journal.addKeyValue('strokeLength', body.linearStrokeLength, 'mm');
  journal.addKeyValue('linearFrequencyCountPerMinute', body.linearFrequency, '1/min');
  journal.addText('\nrotation parameters:');
  journal.addKeyValue('diameter', body.bearingInnerDiameter, 'mm');
  journal.addKeyValue('revolutionsPerMinute', body.rotationRevolutions, '1/min');
  journal.addHeadline('calculation:');
  const list = body.materialDetails.map(material => lifetimeSingleLinearAndRotationalSimultaneous(_extends({}, body, {
    igusMaterialId: material.name,
    materialDetails: material
  }), dryWearData));
  return handleLifetimeMultipleSuccess$1(list, body.wantExplanation, journal);
};
const lifetimeMaterialMultipleLinearAndRotationSequential = (body, temporalLinearPart, dryWearData) => {
  const logger = new TrsExplanationJournal();
  logger.addTrsLifetimeIntro('lifetimeMaterialMultipleLinearAndRotation()', body, false);
  const surfacePressure = getSurfacePressure(body.load);
  logger.addHeadline('basic parameter validation:');
  const checkResult = checkValues([...getCommonCheckRows(surfacePressure, body)]);
  logger.addText(checkResult.explanation);
  if (checkResult.value > 0) {
    const errorText = checkResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    return new LifetimeMultipleResultError(errorText, logger.getJournal());
  }
  logger.addText('\nlinear parameters:');
  logger.addKeyValue('strokeLength', body.linearStrokeLength, 'mm');
  logger.addKeyValue('linearFrequencyCountPerMinute', body.linearFrequency, '1/min');
  logger.addText('\nrotation parameters:');
  logger.addKeyValue('diameter', body.bearingInnerDiameter, 'mm');
  logger.addKeyValue('revolutionsPerMinute', body.rotationRevolutions, '1/min');
  logger.addHeadline('calculation:');
  const list = body.materialDetails.map(material => lifetimeSingleLinearAndRotationalSequential(_extends({}, body, {
    igusMaterialId: material.name,
    materialDetails: material
  }), temporalLinearPart, dryWearData));
  return handleLifetimeMultipleSuccess$1(list, body.wantExplanation, logger);
};

const isSingleMaterialResult = results => !('list' in results);
const isMultipleMaterialResult = results => 'list' in results;
const isSuccess = results => {
  return !('error' in results);
};
const isError = results => {
  return 'error' in results;
};
const bearingShapedAreaCalculation = (lifetimeFormValues, unitSystem = UnitSystem.metric) => {
  const {
    bearingInnerDiameter,
    bearingLength
  } = lifetimeFormValues;
  const result = bearingInnerDiameter * bearingLength;
  const precision = unitSystem === UnitSystem.imperial ? 1000 : 100;
  return Math.round((result + Number.EPSILON) * precision) / precision;
};
const thrustWasherAreaCalculation = (lifetimeFormValues, unitSystem = UnitSystem.metric) => {
  const {
    bearingOuterDiameter,
    bearingInnerDiameter
  } = lifetimeFormValues;
  const result = Math.PI / 4 * (Math.pow(bearingOuterDiameter, 2) - Math.pow(bearingInnerDiameter, 2));
  const precision = unitSystem === UnitSystem.imperial ? 1000 : 100;
  return Math.round((result + Number.EPSILON) * precision) / precision;
};
const pickAreaCalculationFn = isThrustWasherShape => {
  return isThrustWasherShape ? thrustWasherAreaCalculation : bearingShapedAreaCalculation;
};
const isTShaped = partShape => {
  return partShape === 'T';
};

/**
 * Calculates the lifetime in hours for a multiple rotation movement articles
 */
const lifetimeDdxArticlesBatchRotation = ({
  wantExplanation,
  articles
}, materials, dryWearData) => {
  const journal = new TrsExplanationJournal();
  journal.addHeadline('TRS lifetime rotation calculations for multiple articles');
  journal.addHeadline('Articles areas calculations:');
  const rotationArticles = articles.map((article, inx) => {
    const {
      articleShape,
      unitSystem,
      pvCalculationParams
    } = article;
    const areaFn = pickAreaCalculationFn(isTShaped(articleShape));
    const area = areaFn({
      bearingInnerDiameter: pvCalculationParams.bearingInnerDiameter,
      bearingOuterDiameter: pvCalculationParams.bearingOuterDiameter,
      bearingLength: pvCalculationParams.bearingLength
    }, unitSystem != null ? unitSystem : UnitSystem.metric);
    journal.addText(`calculated area for article with inx ${inx} is ${area}`);
    return _extends({}, article, {
      load: _extends({}, article.load, {
        area
      }),
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      materialDetails: materials.find(material => material.id === article.igusMaterialId)
    });
  });
  const articlesLifetime = rotationArticles.map(article => {
    const lifetime = lifetimeSingleRotation(article, dryWearData);
    return _extends({}, lifetime, {
      explanation: wantExplanation && article.wantExplanation ? lifetime.explanation : undefined
    });
  });
  return new LifetimeMultipleResultSuccess(articlesLifetime, wantExplanation ? journal.getJournal() : undefined);
};

const _excluded = ["explanation"];
const handleLifetimeMultipleSuccess = (results, wantExplanation, journal) => {
  const simpleResults = Object.entries(results).sort(([, valueA], [, valueB]) => valueA.isSuccess() && valueB.isSuccess() ? valueB.lifetime - valueA.lifetime : valueB.isSuccess() ? 1 : -1).map(([partId, _ref]) => {
    let {
        explanation
      } = _ref,
      lifetime = _objectWithoutPropertiesLoose(_ref, _excluded);
    return _extends({}, lifetime, {
      partId,
      explanation: wantExplanation ? explanation : undefined
    });
  });
  return new LifetimeMultipleResultSuccess(simpleResults, wantExplanation ? journal.getJournal() : undefined);
};
const validateParts = (body, journal) => {
  const loadsPerPart = new Map();
  const basicValidations = body.parts.map(part => {
    const {
      isTShape,
      innerDiameter,
      length,
      outerDiameter,
      partId
    } = part;
    if (body.load.force) {
      var _body$unitSystem;
      const areaFn = pickAreaCalculationFn(isTShape);
      const area = areaFn({
        bearingInnerDiameter: innerDiameter,
        bearingOuterDiameter: outerDiameter,
        bearingLength: length
      }, (_body$unitSystem = body.unitSystem) != null ? _body$unitSystem : UnitSystem.metric);
      journal.addHeadline(`calculated area for ${partId} is ${area}`);
      body.load = _extends({}, body.load, {
        area
      });
    }
    loadsPerPart.set(partId, body.load);
    const surfacePressure = getSurfacePressure(body.load);
    journal.addHeadline(`basic parameter validation: ${partId}`);
    const checkResult = checkValues([...getCommonCheckRows(surfacePressure, body)]);
    journal.addText(checkResult.explanation);
    if (checkResult.value > 0) {
      return checkResult.value === 1 ? '\nError - One parameter is out of range. Calculation stopped!' : '\nError - Some parameters are out of range. Calculation stopped!';
    }
  }).filter(validation => validation);
  if (basicValidations.length) {
    return {
      loadsPerPart,
      error: new LifetimeMultipleResultError(basicValidations.join('\n'), journal.getJournal())
    };
  }
  return {
    loadsPerPart
  };
};

/**
 * calculates the lifetime in hours for a linear movement for all igus koplaMaterial
 *
 * @param body LifetimePartsLinearParams
 * @param materials KoplaMaterial[]
 */
const lifetimePartsLinear = (body, materials, dryWearData) => {
  const journal = new TrsExplanationJournal();
  journal.addTrsLifetimeIntro('lifetimePartsLinear', body, false);
  const {
    error,
    loadsPerPart
  } = validateParts(body, journal);
  if (error) {
    return error;
  }
  journal.addText('\nlinear parameters:');
  journal.addKeyValue('strokeLength', body.linearStrokeLength, 'mm');
  journal.addKeyValue('linearFrequencyCountPerMinute', body.linearFrequency, '1/min');
  journal.addHeadline('calculation:');
  const list = body.parts
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  .map(part => ({
    part,
    load: loadsPerPart.get(part.partId)
  })).reduce((acc, {
    part,
    load
  }) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const material = materials.find(({
      id
    }) => id === part.materialId);
    const lifetime = lifetimeSingleLinear(_extends({}, body, {
      load,
      materialDetails: material,
      igusMaterialId: material == null ? void 0 : material.name
    }), dryWearData);
    return _extends({}, acc, {
      [part.partId]: lifetime
    });
  }, {});
  return handleLifetimeMultipleSuccess(list, body.wantExplanation, journal);
};

/**
 * calculates the lifetime in hours for a pivoting movement for all igus koplaMaterial
 *
 * @param body LifetimePartsPivotingParams
 * @param materials KoplaMaterial[]
 */
const lifetimePartsPivoting = (body, materials, dryWearData) => {
  const journal = new TrsExplanationJournal();
  journal.addTrsLifetimeIntro('lifetimePartsPivoting', body, false);
  const {
    error,
    loadsPerPart
  } = validateParts(body, journal);
  if (error) {
    return error;
  }
  journal.addText('\npivoting parameters:');
  journal.addKeyValue('pivotingAngle', body.pivotingAngle, '°');
  journal.addKeyValue('pivotingFrequencyCountPerMinute', body.pivotingFrequency, '1/min');
  journal.addHeadline('calculation:');
  const list = body.parts.map(part => ({
    part,
    load: loadsPerPart.get(part.partId)
  })).reduce((acc, {
    part,
    load
  }) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const material = materials.find(({
      id
    }) => id === part.materialId);
    const lifetime = lifetimeSinglePivoting(_extends({}, body, {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      load: load,
      materialDetails: material,
      igusMaterialId: material == null ? void 0 : material.name,
      bearingInnerDiameter: part.innerDiameter
    }), dryWearData);
    return _extends({}, acc, {
      [part.partId]: lifetime
    });
  }, {});
  return handleLifetimeMultipleSuccess(list, body.wantExplanation, journal);
};

/**
 * calculates the lifetime in hours for a rotating movement for all igus koplaMaterial
 *
 * @param body LifetimePartsRotationParams
 * @param materials KoplaMaterial[]
 */
const lifetimePartsRotation = (body, materials, dryWearData) => {
  const journal = new TrsExplanationJournal();
  journal.addTrsLifetimeIntro('lifetimePartsRotation', body, false);
  const {
    error,
    loadsPerPart
  } = validateParts(body, journal);
  if (error) {
    return error;
  }
  journal.addText('\nrotation parameters:');
  journal.addKeyValue('rotationRevolutions', body.rotationRevolutions, '1/min');
  journal.addHeadline('calculation:');
  const list = body.parts.map(part => ({
    part,
    load: loadsPerPart.get(part.partId)
  })).reduce((acc, {
    part,
    load
  }) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const material = materials.find(({
      id
    }) => id === part.materialId);
    const lifetime = lifetimeSingleRotation(_extends({}, body, {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      load: load,
      materialDetails: material,
      igusMaterialId: material == null ? void 0 : material.name,
      bearingInnerDiameter: part.innerDiameter
    }), dryWearData);
    return _extends({}, acc, {
      [part.partId]: lifetime
    });
  }, {});
  return handleLifetimeMultipleSuccess(list, body.wantExplanation, journal);
};

const logCommonProperties$1 = (body, journal) => {
  journal.addText('\nlinear parameters:');
  journal.addKeyValue('strokeLength', body.linearStrokeLength, 'mm');
  journal.addKeyValue('linearFrequencyCountPerMinute', body.linearFrequency, '1/min');
  journal.addText('\nrotation parameters:');
  journal.addKeyValue('revolutionsPerMinute', body.rotationRevolutions, '1/min');
};
const lifetimePartsLinearAndRotationSimultaneous = (body, materials, dryWearData) => {
  const journal = new TrsExplanationJournal();
  journal.addTrsLifetimeIntro('lifetimePartsLinearAndRotationSimultaneous', body, false);
  const {
    error,
    loadsPerPart
  } = validateParts(body, journal);
  if (error) {
    return error;
  }
  logCommonProperties$1(body, journal);
  journal.addHeadline('calculation:');
  const list = body.parts
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  .map(part => ({
    part,
    load: loadsPerPart.get(part.partId)
  })).reduce((acc, {
    part,
    load
  }) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const material = materials.find(({
      id
    }) => id === part.materialId);
    const lifetime = lifetimeSingleLinearAndRotationalSimultaneous(_extends({}, body, {
      load,
      materialDetails: material,
      igusMaterialId: material == null ? void 0 : material.name,
      bearingInnerDiameter: part.innerDiameter
    }), dryWearData);
    return _extends({}, acc, {
      [part.partId]: lifetime
    });
  }, {});
  return handleLifetimeMultipleSuccess(list, body.wantExplanation, journal);
};
const lifetimePartsLinearAndRotationSequential = (body, materials, temporalLinearPart, dryWearData) => {
  const journal = new TrsExplanationJournal();
  journal.addTrsLifetimeIntro('lifetimePartsLinearAndRotationSequential', body, false);
  const {
    error,
    loadsPerPart
  } = validateParts(body, journal);
  if (error) {
    return error;
  }
  logCommonProperties$1(body, journal);
  journal.addHeadline('calculation:');
  const list = body.parts
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  .map(part => ({
    part,
    load: loadsPerPart.get(part.partId)
  })).reduce((acc, {
    part,
    load
  }) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const material = materials.find(({
      id
    }) => id === part.materialId);
    const lifetime = lifetimeSingleLinearAndRotationalSequential(_extends({}, body, {
      load,
      materialDetails: material,
      igusMaterialId: material == null ? void 0 : material.name,
      bearingInnerDiameter: part.innerDiameter
    }), temporalLinearPart, dryWearData);
    return _extends({}, acc, {
      [part.partId]: lifetime
    });
  }, {});
  return handleLifetimeMultipleSuccess(list, body.wantExplanation, journal);
};

const logCommonProperties = (body, journal) => {
  journal.addText('\nlinear parameters:');
  journal.addKeyValue('strokeLength', body.linearStrokeLength, 'mm');
  journal.addKeyValue('linearFrequencyCountPerMinute', body.linearFrequency, '1/min');
  journal.addText('\npivoting parameters:');
  journal.addKeyValue('pivotingAngle', body.pivotingAngle, '°');
  journal.addKeyValue('pivotingFrequencyCountPerMin', body.pivotingFrequency, '1/min');
};
const lifetimePartsLinearAndPivotingSimultaneous = (body, materials, dryWearData) => {
  const journal = new TrsExplanationJournal();
  journal.addTrsLifetimeIntro('lifetimePartsLinearAndPivotingSimultaneous', body, false);
  const {
    error,
    loadsPerPart
  } = validateParts(body, journal);
  if (error) {
    return error;
  }
  logCommonProperties(body, journal);
  journal.addHeadline('calculation:');
  const list = body.parts
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  .map(part => ({
    part,
    load: loadsPerPart.get(part.partId)
  })).reduce((acc, {
    part,
    load
  }) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const material = materials.find(({
      id
    }) => id === part.materialId);
    const lifetime = lifetimeSingleLinearAndPivotingSimultaneous(_extends({}, body, {
      load,
      materialDetails: material,
      igusMaterialId: material == null ? void 0 : material.name,
      bearingInnerDiameter: part.innerDiameter
    }), dryWearData);
    return _extends({}, acc, {
      [part.partId]: lifetime
    });
  }, {});
  return handleLifetimeMultipleSuccess(list, body.wantExplanation, journal);
};
const lifetimePartsLinearAndPivotingSequential = (body, materials, temporalLinearPart, dryWearData) => {
  const journal = new TrsExplanationJournal();
  journal.addTrsLifetimeIntro('lifetimePartsLinearAndRotationSequential', body, false);
  const {
    error,
    loadsPerPart
  } = validateParts(body, journal);
  if (error) {
    return error;
  }
  logCommonProperties(body, journal);
  journal.addHeadline('calculation:');
  const list = body.parts
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  .map(part => ({
    part,
    load: loadsPerPart.get(part.partId)
  })).reduce((acc, {
    part,
    load
  }) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const material = materials.find(({
      id
    }) => id === part.materialId);
    const lifetime = lifetimeSingleLinearAndPivotingSequential(_extends({}, body, {
      load,
      materialDetails: material,
      igusMaterialId: material == null ? void 0 : material.name,
      bearingInnerDiameter: part.innerDiameter
    }), temporalLinearPart, dryWearData);
    return _extends({}, acc, {
      [part.partId]: lifetime
    });
  }, {});
  return handleLifetimeMultipleSuccess(list, body.wantExplanation, journal);
};

/**
 * TODO: Probably more part shape types are needed.
 * Should be extended.
 */
const partShapeArray = ['S', 'T'];

const lifetimeFieldNameArray = ['environment', 'igusMaterial', 'oppositeMaterial', 'enabledPVCalculation', 'housingMaterial', 'bearingInnerDiameter', 'bearingOuterDiameter', 'enabledBearingWallThickness', 'bearingWallThickness', 'bearingLength', 'enabledIntermittentCalculation', 'intermittentOnTime', 'intermittentOffTime', 'force', 'area', 'surfacePressure', 'diameter', 'temperature', 'acceptableWear', 'activityMinutesPerHour', 'spacialTypeOfMovement', 'temporalTypeOfMovement', 'temporalLinearPart', 'linearStrokeLength', 'linearFrequency', 'rotationRevolutions', 'pivotingAngle', 'pivotingFrequency'];
const defaultLifetimeFormConfig = {
  environment: {
    // for now only `dry` is supported
    visible: true,
    disabled: true,
    default: 'dry'
  },
  igusMaterial: {
    // ignored because we want to get the list for all materials
    visible: false,
    disabled: false,
    default: 'G'
  },
  oppositeMaterial: {
    visible: true,
    disabled: false,
    default: '1' // 1 = Cf53
  },
  enabledPVCalculation: {
    // the switch is not shown, but the sub-template should be displayed
    visible: false,
    disabled: false,
    default: true
  },
  housingMaterial: {
    visible: true,
    disabled: false,
    default: '2' /// 2 = Aluminium
  },
  bearingInnerDiameter: {
    // comes from the "graphical borehole selector"
    visible: true,
    disabled: false,
    // default: 10,
    unit: 'distanceMilli',
    min: 1,
    max: 200,
    toImperial: value => fromMetricDistanceMilli(UnitSystem.imperial, value)
  },
  bearingOuterDiameter: {
    // calculated from  = BEARING_INNER_DIAMETER + 2 * BEARING_WALL_THICKNESS
    visible: true,
    disabled: false,
    // default: 12,
    unit: 'distanceMilli',
    min: 1,
    max: 200,
    toImperial: value => fromMetricDistanceMilli(UnitSystem.imperial, value)
  },
  enabledBearingWallThickness: {
    visible: false,
    disabled: false,
    default: true
  },
  bearingWallThickness: {
    visible: true,
    disabled: false,
    // default: 1,
    unit: 'distanceMilli',
    min: 0.5,
    max: 5,
    toImperial: value => fromMetricDistanceMilli(UnitSystem.imperial, value)
  },
  bearingLength: {
    // comes from the graphical borehole selector
    visible: true,
    disabled: false,
    // default: 20,
    unit: 'distanceMilli',
    min: 1,
    max: 80,
    toImperial: value => fromMetricDistanceMilli(UnitSystem.imperial, value)
  },
  enabledIntermittentCalculation: {
    visible: true,
    disabled: false,
    default: false
  },
  intermittentOnTime: {
    visible: true,
    disabled: false,
    // default: 20,
    unit: 'time',
    min: 1,
    max: 600,
    toImperial: value => fromMetricTime(UnitSystem.imperial, value)
  },
  intermittentOffTime: {
    visible: true,
    disabled: false,
    // default: 80,
    unit: 'time',
    min: 1,
    max: 600,
    toImperial: value => fromMetricTime(UnitSystem.imperial, value)
  },
  force: {
    visible: true,
    disabled: false,
    // default: 100,
    unit: 'force',
    min: 0.00001,
    max: 100000000,
    toImperial: value => fromMetricForce(UnitSystem.imperial, value)
  },
  area: {
    visible: true,
    disabled: false,
    unit: 'areaMilli',
    min: 1,
    max: 1000,
    toImperial: value => fromMetricAreaMilli(UnitSystem.imperial, value)
  },
  diameter: {
    visible: true,
    disabled: false,
    // default: 500,
    unit: 'distanceMilli',
    toImperial: value => fromMetricDistanceMilli(UnitSystem.imperial, value)
  },
  surfacePressure: {
    visible: false,
    disabled: false,
    // default: 10,
    unit: 'pressureMega',
    min: 0.00001,
    max: 100,
    toImperial: value => fromMetricPressureMega(UnitSystem.imperial, value)
  },
  temperature: {
    visible: true,
    disabled: true,
    // IGL-4049 Entering different temperatures has no effect on the service life calculation, which is why we should fix the temperature at 23 °C (73,4 °F for imperial).
    default: 23,
    unit: 'temperature',
    min: -273,
    max: 200,
    toImperial: value => fromMetricTemperature(UnitSystem.imperial, value)
  },
  acceptableWear: {
    visible: true,
    disabled: false,
    // default: 0.25,
    unit: 'distanceMilli',
    min: 0.001,
    max: 2,
    toImperial: value => fromMetricDistanceMilli(UnitSystem.imperial, value)
  },
  activityMinutesPerHour: {
    visible: true,
    disabled: false,
    // default: 60,
    unit: 'timeMinute',
    min: 1,
    max: 60,
    toImperial: value => fromMetricTime(UnitSystem.imperial, value)
  },
  spacialTypeOfMovement: {
    visible: true,
    disabled: false,
    default: 'rotation'
  },
  linearStrokeLength: {
    visible: true,
    disabled: false,
    // default: 1000,
    unit: 'distanceMilli',
    min: 1,
    max: 3000,
    toImperial: value => fromMetricDistanceMilli(UnitSystem.imperial, value)
  },
  linearFrequency: {
    visible: true,
    disabled: false,
    // default: 1,
    unit: 'rotationalVelocity',
    min: 1,
    max: 1000
  },
  rotationRevolutions: {
    visible: true,
    disabled: false,
    // default: 500,
    unit: 'rotationalVelocity',
    min: 0.01,
    max: 1000
  },
  pivotingAngle: {
    visible: true,
    disabled: false,
    // default: 15,
    unit: 'angle',
    min: 0,
    max: 45,
    toImperial: value => fromMetricAngle(UnitSystem.imperial, value)
  },
  pivotingFrequency: {
    visible: true,
    disabled: false,
    // default: 2,
    unit: 'rotationalVelocity',
    min: 0.01,
    max: 1000
  },
  temporalTypeOfMovement: {
    visible: true,
    disabled: false,
    default: 'sequential'
  },
  temporalLinearPart: {
    visible: true,
    disabled: false,
    // default: 0.5,
    min: 0,
    max: 1
  }
};

/* -----------------------------------------------
 * Error messages
 * ----------------------------------------------- */
var ChartError;
(function (ChartError) {
  ChartError["valid"] = "Valid";
  ChartError["errorIgusMaterialNotSet"] = "Error: igus material not set";
  ChartError["errorIgusMaterialNotFound"] = "Error: igus material not found";
  ChartError["errorOppositeMaterialNotSet"] = "Error: opposite material not set";
  ChartError["errorOppositeMaterialNotFound"] = "Error: opposite material not found";
  ChartError["errorSpatialTypeOfMovementNotSet"] = "Error: spatial type of movement not set";
  ChartError["errorSpatialTypeOfMovementNotYetSupported"] = "Error: spatial type of movement not yet supported";
  ChartError["errorEnvironmentNotSet"] = "Error: environment not set";
  ChartError["errorEnvironmentNotYetSupported"] = "Error: environment not yet supported";
  ChartError["errorSurfacePressureNotSet"] = "Error: SurfacePressure not set";
  ChartError["errorSurfacePressureOutOfRange"] = "Error: SurfacePressure out of range";
  ChartError["errorTemperatureNotSet"] = "Error: Temperature not set";
  ChartError["errorTemperatureOutOfRange"] = "Error: Temperature out of range";
  ChartError["errorVelocityNotSet"] = "Error: Velocity not set";
  ChartError["errorVelocityOutOfRange"] = "Error: Velocity out of range";
  ChartError["errorNoData"] = "Error: No data for the given material combination and movement.";
  ChartError["errorUndefinedTypeOfMovement"] = "Error: type of movement not defined";
})(ChartError || (ChartError = {}));

export { ChartError, HousingMaterialIds, LifetimeMultipleResultError, LifetimeMultipleResultSuccess, LifetimeSingleResultError, LifetimeSingleResultSuccess, ModeOfWearCalculation, OppositeMaterialIds, SpatialTypeOfMovementDual, SpatialTypeOfMovementSingle, TechnicalEnvironment, TemporalTypeOfMovement, WearError, areaFactor, areaImperialToMetric, areaMetricToImperial, bearingShapedAreaCalculation, calcCoefficientOfFriction, calculateWearWithChecks, defaultLifetimeFormConfig, distanceFactor, distanceImperialToMetric, distanceMetricToImperial, forceFactor, forceImperialToMetric, forceMetricToImperial, getAllLifetimeInputParameterLimits, getHousingMaterialById, getHousingMaterialEnumKey, getHousingMaterials, getIgusMaterialNames, getLifetimeInputParameterLimits, getOppositeMaterialById, getOppositeMaterialEnumKey, getOppositeMaterialIds, getOppositeMaterialNames, getOppositeMaterials, getPressureCofByIgusMaterialName, getTypeOfMovementInExcel, isError, isMultipleMaterialResult, isPvCalculationParamsWtByDiameters, isPvCalculationParamsWtByWt, isSingleMaterialResult, isSuccess, isTShaped, isWearErrorResult, isWearSuccessResult, lifetimeDdxArticlesBatchRotation, lifetimeFieldNameArray, lifetimeMaterialMultipleLinear, lifetimeMaterialMultipleLinearAndPivotingSequential, lifetimeMaterialMultipleLinearAndPivotingSimultaneous, lifetimeMaterialMultipleLinearAndRotationSequential, lifetimeMaterialMultipleLinearAndRotationSimultaneous, lifetimeMaterialMultiplePivoting, lifetimeMaterialMultipleRotation, lifetimePartsLinear, lifetimePartsLinearAndPivotingSequential, lifetimePartsLinearAndPivotingSimultaneous, lifetimePartsLinearAndRotationSequential, lifetimePartsLinearAndRotationSimultaneous, lifetimePartsPivoting, lifetimePartsRotation, lifetimeSingleLinear, lifetimeSingleLinearAndPivotingSequential, lifetimeSingleLinearAndPivotingSimultaneous, lifetimeSingleLinearAndRotationalSequential, lifetimeSingleLinearAndRotationalSimultaneous, lifetimeSinglePivoting, lifetimeSingleRotation, parameterNames, partShapeArray, pickAreaCalculationFn, pressureFactor, pressureImperialToMetric, pressureMetricToImperial, spatialTypeOfMovements, spatialTypeOfMovementsPerValues, temperatureImperialToMetric, temperatureMetricToImperial, thrustWasherAreaCalculation, toLifetimeSingleResult, velocityFactor, velocityImperialToMetric, velocityMetricToImperial, wearPerHourFactor, wearPerHourImperialToMetric, wearPerHourMetricToImperial };
